/**
 * @ Author: Housefolios
 * @ Create Time: 2021-12-01 15:08:58
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-27 13:27:45
 * @ Description: Property details view showing the comps found for this property
 */

import React, { Fragment, useEffect, useRef, useState } from 'react'
import {
  strategyAbsTopRight10Sx,
  strategyAbsTopRightPinkSx,
  strategyAvatarBlueLargeSx,
  strategyBoxShadowNoneSx,
  strategyCenterTextSx,
  strategyCompCardSx,
  strategyCompImgSx,
  strategyDangerChipSx,
  strategyDarkTextSx,
  strategyDrawerLegendSx,
  strategyErrorTextSx,
  strategyFixedBottomBarSx,
  strategyFlexGrowSx,
  strategyFlexSelfCenterSx,
  strategyFullHeight100Sx,
  strategyFullSizeSx,
  strategyFullWidthSx,
  strategyHighlightBlueSx,
  strategyIconBlueBgSx,
  strategyIconGap10Style,
  strategyIconSize40Sx,
  strategyMargin20VerticalSx,
  strategyMarginBottom25Sx,
  strategyMarginBottomNeg30Sx,
  strategyMarginRight10Sx,
  strategyMarginTop10OnlySx,
  strategyMarginTop10Sx,
  strategyMarginTop12Sx,
  strategyMarginTop5Sx,
  strategyMinSelectSx,
  strategyMutedGraySx,
  strategyOverflowScrollSx,
  strategyPad10Sx,
  strategyPad5Sx,
  strategyPadBottom0Sx,
  strategyPadVert15Sx,
  strategyPagePadSx,
  strategyPositionCloseSx,
  strategyRelPosSx,
  strategySemiboldPullUpSx,
  strategyTransparentCenterSx,
  strategyTransparentRelCenterSx,
  strategyWhiteSpaceNormalSx,
  strategyWhiteTextSx,
  strategyWidth400Sx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Cropper from 'react-easy-crop'

// Centralized lodash imports - much cleaner!
import {
  map,
  isEmpty,
  minBy,
  maxBy,
  meanBy,
  filter,
  remove,
  toUpper,
  toLower,
  sum,
  padStart,
  head,
  toString,
  replace,
  intersection,
  includes,
  isEqual,
  pull,
  ceil,
  slice,
  intersectionBy,
  concat,
  compact,
  startCase,
  reduce,
  forEach,
  uniqWith,
  orderBy,
  isNil,
  get,
  isString,
  every,
  split,
  kebabCase,
  cloneDeep,
  find,
  set,
  round,
} from '@/utils/lodash'

import Slider1 from 'react-slick'

import CompsCard from '../CompsCard'
import CountUp from '@/utils/SafeCountUp'

import loadImage from '@/utils/loadImage'

import { useDropzone } from 'react-dropzone'

import {
  Avatar,
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  ImageListItemBar,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  Slider,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Popover,
  Typography,
  FormControl,
  InputLabel,
  TableSortLabel,
  Box,
} from '@mui/material'
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone'
import CheckIcon from '@mui/icons-material/Check'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import CloudUploadTwoToneIcon from '@mui/icons-material/CloudUploadTwoTone'
import CompareIcon from '@mui/icons-material/Compare'
import EditIcon from '@mui/icons-material/Edit'
import HomeIcon from '@mui/icons-material/Home'
import LinearScaleIcon from '@mui/icons-material/LinearScale'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import ListIcon from '@mui/icons-material/List'
import {
  GET_COMPPROPERTIES,
  GET_PROPERTY,
} from '@/housefolios-components/PropertyContainer/queries'
import { ApolloConsumer } from '@/components/ApolloConsumer'
import { useLazyQuery, useMutation } from '@apollo/client/react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import {
  ADD_COMPPROPERTY,
  ADD_COMPPROPERTIES,
  IMAGE_UPLOAD,
  IMAGE_UPLOAD_MULTI,
} from '@/housefolios-components/TitleButtons/AddPropertyButton/mutations'
import { NumericFormat } from 'react-number-format'
import { enqueueSnackbar } from 'notistack'
import {
  DELETE_COMP,
  DELETE_IMAGE_MULTI,
  UPDATE_COMPPROPERTY,
  UPDATE_COMPPROPERTIES,
  SAVE_ANALYSIS,
  DELETE_IMAGE,
  DELETE_COMP_MULTI,
} from '@/housefolios-components/PropertyContainer/mutations'

import {
  arrayMove,
  SortableItem,
  SortableList,
} from '@/components/sortable'

import Map from '../../../Properties/Map'
import { PacmanLoader } from 'react-spinners'
import BlockUi from 'react-block-ui'
import {
  CheckBox,
  CheckBoxOutlineBlank,
  CloseOutlined,
  DeleteTwoTone,
  GridOnTwoTone,
  KeyboardArrowDownTwoTone,
  PollTwoTone,
  RoomTwoTone,
} from '@mui/icons-material'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import Alert from '@mui/material/Alert'
import DeleteComps from '@/housefolios-components/Comps/DeleteComps'
import MyPropertiesFilter from '@/layout-components/HeaderDrawer'
import CompsList from '../CompsList'
import Pagination from '@mui/material/Pagination'
import {
  PropertyCardSkeleton,
  PropertyListSkeleton,
} from '@/housefolios-components/Property/PropertyCardSkeleton'
import { GET_ZIP_VALUE } from '@/housefolios-components/TitleButtons/AddPropertyButton/queries'
import { GET_STOCKPILE } from '@/housefolios-components/Marketplace/queries'
import { STATES } from '@/constants/states'
import Autocomplete from '@mui/material/Autocomplete'
import { useStopwatch } from 'react-timer-hook'
import AllPropertiesFiltered from '@/housefolios-components/Properties/AllPropertiesFiltered'
import ImageCropper from '@/housefolios-components/Dialogs/ImageCropper'
import withSession from '@/housefolios-components/Session/withSession'
import { handlePlaceResult } from '@/utils/handlePlaceResult'
import { usePlaceAutocomplete } from '@/utils/placeAutocomplete'
import { getZipValues } from '@/utils/addProperty'
import { GET_REALEFLOW_COMPS } from '@/housefolios-components/Comps/queries'
import useSorting from '@/hooks/useSorting'
import { statesShort } from '@/utils/states'
import { formatDateYmd } from '@/utils/date'
import { searchToolbarIconButtonProps } from '@/theme/skinSx'
import { compMarkerColor } from '@/housefolios-components/PropertyContainer/CenterPage/compMarkerColors'

const ORIENTATION_TO_ANGLE = {
  3: 180,
  6: 90,
  8: -90,
}

const hostname = import.meta.env.VITE_HOSTNAME
const apiKey = import.meta.env.VITE_HOUSEFOLIOS_APIKEY
const apiID = import.meta.env.VITE_HOUSEFOLIOS_APIID
const googleApiKey = import.meta.env.VITE_GOOGLE_APIKEY

let sortingChoices = [
  {
    title: 'Price - low to high',
    textAlign: 'left',
    name: 'estval-asc',
  },
  {
    title: 'Price - high to low',
    textAlign: 'left',
    name: 'estval-desc',
  },
  {
    title: 'SqFt - low to high',
    name: 'sqft-asc',
  },
  {
    title: 'SqFt - high to low',
    name: 'sqft-desc',
  },
  {
    title: 'Year - low to high',
    name: 'year-asc',
  },
  {
    title: 'Year - high to low',
    name: 'year-desc',
  },
]

//Sorting function copied from properties/marketplace page. Removed marketplaceOrderBy.
function desc(a, b, orderBy) {
  if (isString(get(a, orderBy)) && isString(get(b, orderBy))) {
    if (!get(b, orderBy) && !get(a, orderBy)) {
      return 0
    }
    if (!get(b, orderBy)) {
      return 1
    }
    if (!get(a, orderBy)) {
      return -1
    }
    if (
      every(get(a, orderBy), (c) => c <= '9' && c >= '0') &&
      every(get(b, orderBy), (c) => c <= '9' && c >= '0')
    ) {
      if (Number(get(b, orderBy)) < Number(get(a, orderBy))) {
        return -1
      }
      if (Number(get(b, orderBy)) > Number(get(a, orderBy))) {
        return 1
      }
      return 0
    } else {
      if (
        get(b, orderBy).toLowerCase() < get(a, orderBy).toLowerCase()
      ) {
        return -1
      }
      if (
        get(b, orderBy).toLowerCase() > get(a, orderBy).toLowerCase()
      ) {
        return 1
      }
      return 0
    }
  } else {
    if (isNil(get(b, orderBy)) && isNil(get(a, orderBy))) {
      return 0
    }
    if (isNil(get(b, orderBy))) {
      return 1
    }
    if (isNil(get(a, orderBy))) {
      return -1
    }
    if (get(b, orderBy) < get(a, orderBy)) {
      return -1
    }
    if (get(b, orderBy) > get(a, orderBy)) {
      return 1
    }
    return 0
  }
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy)
}

function SliderArrowNext(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

const REHAB_LEVELS = [
  {
    value: 'Fully Rehabbed',
    label: 'Fully Rehabbed',
  },
  {
    value: 'Partially Rehabbed',
    label: 'Partially Rehabbed',
  },
  {
    value: 'No Rehab Needed',
    label: 'No Rehab Needed',
  },
  {
    value: 'Needs Partial Rehab',
    label: 'Needs Partial Rehab',
  },
  {
    value: 'Needs Major Rehab',
    label: 'Needs Major Rehab',
  },
]

const realeflowStatusValues = [
  {
    value: 'S',
    label: 'Sold',
  },
  {
    value: 'A',
    label: 'Avaliable',
  },
  {
    value: 'P',
    label: 'Pending',
  },
]

function CenterPageComps(props) {
  const {
    property = {},
    comps,
    compsLoading,
    compsBackendLoading,
    compValues,
    organization,
  } = props

  const showCompsSkeleton =
    (compsLoading || compsBackendLoading) && isEmpty(comps)

  const hiddenUp = useMediaQuery((theme) =>
    theme.breakpoints.up('md'),
  )

  const numberFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const [activeTab, setActiveTab] = useState(
    localStorage.getItem('comp-view')
      ? localStorage.getItem('comp-view')
      : props.session?.me?.activeOrg?.isRealeflow
        ? '2'
        : '1',
  )

  const [alignment, setAlignment] = useState('actual')

  const toggleAlignment = (_event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment)
    }
  }

  const [compMenu, setCompMenu] = useState(null)
  const [findCompMenu, setFindCompMenu] = useState(null)
  const [realeflowCompFilters, setRealeflowCompFilters] = useState({
    beds: {
      min: Number(property.beds) - 1,
      max: Number(property.beds) + 1,
    },
    baths: {
      min: Number(property.baths) - 1,
      max: Number(property.baths) + 1,
    },
    distance: 0.5,
    squareFeet: {
      min: Number(property.sqft) - 250,
      max: Number(property.sqft) + 250,
    },
    yearBuilt: {
      min: Number(property.year) - 5,
      max: Number(property.year) + 5,
    },
    lastSoldDays: 180,
    propertyType: 'SINGLE_FAMILY_RESIDENTIAL',
    status: [
      {
        value: 'S',
        label: 'Sold',
      },
    ],
  })
  const [realeflowCompMenus, setRealeflowCompMenus] = useState({})
  const handleMenuOpen = (event) => {
    setCompMenu(event.currentTarget)
  }

  const handleMenuClose = (event) => {
    setCompMenu(null)
  }

  const toggleRealeflowCompFilters = (name) => (event) => {
    let newMenus = { ...realeflowCompMenus }
    if (newMenus[name]) {
      newMenus[name] = null
    } else {
      newMenus[name] = event.currentTarget
    }
    setRealeflowCompMenus(newMenus)
  }

  const [realeflowIncludedIds, setRealeflowIncludedIds] = useState([])
  const [realeflowExcludedIds, setRealeflowExcludedIds] = useState([])
  const [realeflowPath, setRealeflowPath] = useState([])

  const [openSearchWarning, setOpenSearchWarning] = useState(false)
  const [openNoCompWarning, setOpenNoCompWarning] = useState(false)
  const [openDuplicateWarning, setOpenDuplicateWarning] =
    useState(false)
  const [duplicateComps, setDuplicateComps] = useState([])

  const [realeflowOrder, { handleRequestSort }] = useSorting({
    defaultOrder: 'desc',
  })

  const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }

  const readRealeflowDateString = (date) => {
    if (!date) return ''
    const year = date.substr(0, 4)
    const month = date.substr(4, 2)
    const day = date.substr(6, 2)
    return `${year}-${month}-${day}`
  }

  const handleFindMenuOpen = (event) => {
    setFindCompMenu(event.currentTarget)
    setRealeflowPath([])
    setRealeflowIncludedIds([])
    setRealeflowExcludedIds([])
    triggerRealeflowSearch()
  }

  const handleFindMenuClose = (event) => {
    setFindCompMenu(null)
    setRealeflowPath([])
    setRealeflowIncludedIds([])
    setRealeflowExcludedIds([])
    setLoader(false)
  }

  const onChangeRealeflowFilter = (event) => {
    const { name, value, type } = event.target
    let newValue = value
    if (type === 'number') newValue = Number(value)
    let newFilters = cloneDeep(realeflowCompFilters)
    set(newFilters, name, newValue)
    setRealeflowCompFilters(newFilters)
  }

  const toggleIncludeComp = (compId) => {
    let newIds = [...realeflowIncludedIds]
    if (includes(newIds, compId)) pull(newIds, compId)
    else newIds.push(compId)
    setRealeflowIncludedIds(newIds)
  }

  const toggleIncludeAllComp = () => {
    const filteredComps = filter(
      results?.data?.getRealeflowCompData,
      (data) => {
        const { property } = data
        return !includes(realeflowExcludedIds, property?._id)
      },
    )
    if (filteredComps.length > realeflowIncludedIds.length)
      setRealeflowIncludedIds(
        map(filteredComps, (comp) => comp?.property?._id),
      )
    else setRealeflowIncludedIds([])
  }

  const toggleExcludeComp = (compId) => {
    let newIds = [...realeflowExcludedIds]
    if (includes(newIds, compId)) pull(newIds, compId)
    else newIds.push(compId)
    setRealeflowExcludedIds(newIds)
  }

  const [getRealeflowCompData, results] = useLazyQuery(
    GET_REALEFLOW_COMPS,
  )

  const triggerRealeflowSearch = () => {
    setRealeflowIncludedIds([])
    setRealeflowExcludedIds([])
    getRealeflowCompData({
      variables: {
        propertyId: property._id,
        filters: {
          ...realeflowCompFilters,
          status: map(
            realeflowCompFilters?.status,
            (selected) => selected?.value,
          ),
          polygon: realeflowPath,
          // includedIds: realeflowIncludedIds,
          // excludedIds: realeflowExcludedIds,
        },
      },
    })
  }

  const triggerRealeflowSearchReset = () => {
    setRealeflowIncludedIds([])
    setRealeflowExcludedIds([])
  }

  const [selectedEditImage, setSelectedEditImage] = useState({})
  const [replaceImage, setReplaceImage] = useState(false)

  const [editImageMoreVert, setEditImageMoreVert] = useState(null)
  const handleEditImageMoreVertOpen = (event, image) => {
    setEditImageMoreVert(event.currentTarget)
    setSelectedEditImage(image)
  }

  const handleEditImageMoreVertClose = (event) => {
    setEditImageMoreVert(null)
    setSelectedEditImage({})
  }

  const [openEditImage, setOpenEditImage] = useState(false)
  const handleOpenEditImage = (image) => {
    setOpenEditImage(true)
    setSelectedEditImage(image)
  }
  const handleCloseEditImage = () => {
    setOpenEditImage(false)
    // handleEditImageMoreVertClose()
  }

  const saveCroppedImage = async (croppedImage, replaceImage) => {
    setLoader(true)
    try {
      const imageId = get(selectedEditImage, `_id`)
      let newSelectedImages = selectedImages
      if (edit) {
        await imageUpload({
          variables: {
            documentId: compPropertyInput.mainProperty,
            imageUrls: [croppedImage],
            collection: 'compProperty',
          },
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: { propertyId: property._id },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
        })
      } else {
        newSelectedImages = concat(newSelectedImages, [croppedImage])
        setSelectedImages(newSelectedImages)
      }
      if (replaceImage) {
        if (imageId) {
          let newImages = [...images]
          remove(newImages, (image) => image._id === imageId)
          await deleteFile({
            refetchQueries: [
              {
                query: GET_COMPPROPERTIES,
                variables: { propertyId: property._id },
              },
              {
                query: GET_PROPERTY,
                variables: { id: property._id },
              },
            ],
            variables: {
              _id: imageId,
            },
          })
          // setImages(newImages)
        } else {
          pull(newSelectedImages, selectedEditImage)
          setSelectedImages(newSelectedImages)
        }
      }
      enqueueSnackbar(`Image edited`, {
        variant: 'success',
        autoHideDuration: 3000,
      })
    } catch (e) {
      console.error(e)
    }
    handleCloseEditImage()
    handleEditImageMoreVertClose()
    setLoader(false)
  }

  //const [comps, setComps] = useState('soldComps');
  // const handleChange = event => {
  //   setComps(event.target.value);
  // };

  const [openAddCompAddress, setOpenAddCompAddress] = useState(false)
  const handleOpenAddCompAddress = () => {
    setOpenAddCompAddress(true)
    handleMenuClose()
  }
  const handleCloseAddCompAddress = () => {
    setOpenAddCompAddress(false)
    setLoader(false)
    pause()
  }

  const [openVerifyComp, setOpenVerifyComp] = useState(false)
  const handleOpenVerifyComp = () => {
    setOpenVerifyComp(true)
    handleMenuClose()
  }
  const handleCloseVerifyComp = () => {
    setOpenVerifyComp(false)
    setLoader(false)
    pause()
  }

  const [openFixComp, setOpenFixComp] = useState(false)
  const handleOpenFixComp = () => {
    setOpenFixComp(true)
    handleMenuClose()
  }
  const handleCloseFixComp = () => {
    setOpenFixComp(false)
    setLoader(false)
    pause()
  }

  const [loader, setLoader] = useState(false)

  const { seconds, minutes, pause, reset } = useStopwatch({
    autoStart: false,
  })

  const [openAddComp, setOpenAddComp] = useState(false)
  const handleOpenAddComp = () => {
    setOpenAddComp(true)
  }
  const handleCloseAddComp = () => {
    setOpenAddComp(false)
    setLoader(false)
    setAnchorElActionsMenu(null)
    pause()
  }

  const [placeResult, setPlaceResult] = useState(null)

  const [ordering, setOrdering] = useState('')

  const [orderByTarget = 'saleDate', order = 'desc'] = split(
    ordering || 'saleDate-desc',
    '-',
  )

  const [compPropertyInput, setCompPropertyInput] = useState({})
  const [selectedImages, setSelectedImages] = useState([])
  const [images, setImages] = useState([])
  const [edit, setEdit] = useState(false)

  const [items, setItems] = React.useState(
    map(concat(selectedImages, images), (image) => ({
      id: image._id,
      src: image.url,
      url_small: image.url_small,
      width: 4,
      height: 3,
    })),
  )

  const ref = useRef(null)
  const [minHeight, setMinHeight] = React.useState(0)

  const [openManageImages, setOpenManageImages] = useState(false)

  const [openDeleteImage, setOpenDeleteImage] = useState(false)
  const [selectedImageDelete, setSelectedImageDelete] = useState(null)

  const toggleOpenDeleteImage =
    (_id = null) =>
    () => {
      setOpenDeleteImage(!openDeleteImage)
      setSelectedImageDelete(_id)
    }

  const toggleOpenManageImages = () => {
    setOpenManageImages(!openManageImages)
    setMinHeight(0)
  }

  const [menu, setMenu] = useState('')
  const [anchorElDefinition, setAnchorElDefinition] = useState(null)
  const [menuName, setMenuName] = useState(null)
  const [menuFormat, setMenuFormat] = useState(null)
  const [propertyData, setPropertyData] = useState(null)
  const [showMenu, setShowMenu] = useState(true)
  const handleMenu = () => {
    setShowMenu(false)
  }

  const [deleteFiles] = useMutation(DELETE_IMAGE_MULTI, {
    refetchQueries: [
      {
        query: GET_COMPPROPERTIES,
        variables: { propertyId: property._id },
      },
      {
        query: GET_PROPERTY,
        variables: { id: property._id },
      },
    ],
  })

  const handleDefinition = (name, anchorEl, menuName, menuFormat) => {
    setMenu(name)
    setAnchorElDefinition(anchorEl)
    setMenuName(menuName)
    setMenuFormat(menuFormat)
  }

  const onSubmitDelete = async (event) => {
    setLoader(true)
    const toggle = toggleOpenDeleteImage()
    let newImages = [...images]
    remove(newImages, (image) => image._id === selectedImageDelete)
    deleteFiles({
      variables: {
        ids: [selectedImageDelete],
      },
    })
      .then(async ({ data  }) => {
        setSelectedImageDelete(null)
        enqueueSnackbar(`Image Deleted`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
        handleEditImageMoreVertClose()
        toggle()
        setImages(newImages)
        setLoader(false)
      })
      .catch((error) => {
        enqueueSnackbar(`Image failed to delete`, {
          variant: 'error',
          autoHideDuration: 3000,
        })
        toggle()
        setLoader(false)
      })
    event.preventDefault()
  }

  const searchForComp = async (client) => {
    setLoader(true)
    reset()

    let location = handlePlaceResult(placeResult, property)
    const loc = location?.loc
    const streetAddress = location.streetAddress

    const [zipValues] = await getZipValues(
      client,
      location.postal_code,
    )

    let selectedImages = []
    try {
      const stockpileCheck = await client.query({
        query: GET_STOCKPILE,
        variables: {
          addressInput: {
            address: streetAddress,
            city: location.locality,
            county: zipValues ? zipValues.county : '',
            state: location.administrative_area_level_1,
          },
        },
        errorPolicy: 'ignore',
      })
      const stockpileValues = stockpileCheck
        ? stockpileCheck.data
        : null
      const { stockedImages } = stockpileValues || {}
      if (stockedImages) {
        selectedImages = concat(
          selectedImages,
          compact([stockpileValues.stockedImages.first]),
          stockpileValues.stockedImages.url || [],
        )
        if (isEmpty(selectedImages))
          selectedImages = concat(
            selectedImages,
            compact([stockpileValues.stockedImages.streetView]),
            compact([stockpileValues.stockedImages.staticMap]),
          )
      }
      if (loc) {
        const MAP_KEY = googleApiKey
        const { lat, lng } = loc
        if (isEmpty(selectedImages)) {
          var service = window.google
            ? new window.google.maps.StreetViewService()
            : 0
          if (service !== 0) {
            await new Promise((resolve) => {
              try {
                service.getPanoramaByLocation(
                  { lat: Number(lat), lng: Number(lng) },
                  50,
                  function (panoData) {
                    if (panoData !== null) {
                      var ManLatLng = panoData.location.latLng
                      const heading =
                        window.google.maps.geometry.spherical.computeHeading(
                          ManLatLng,
                          new window.google.maps.LatLng(
                            Number(lat),
                            Number(lng),
                          ),
                        )
                      selectedImages.push(
                        `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${lat},${lng}&heading=${heading}&key=${MAP_KEY}`,
                      )
                    }
                    resolve()
                  },
                )
              } catch (error) {
                console.log(error)
                resolve()
              }
            })
          }
          selectedImages.push(
            `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&size=400x400&markers=color:blue%7C${lat},${lng}&key=${MAP_KEY}`,
          )
        }
      }
    } catch (error) {
      console.log(error)
    }

    setCompPropertyInput({
      mainProperty: property._id,
      address: streetAddress,
      city: location.locality || '',
      state: location.administrative_area_level_1 || '',
      zip: location.postal_code || '',
      beds: '',
      baths: '',
      sqft: '',
      year: '',
      estval: '',
      priceAdjustment: 0,
      daysOnMarket: 0,
      rehabLevel: '',
      status: '',
      propertyType: '',
      saleDate: null,
      location: loc
        ? {
            latitude: Number(loc.lat),
            longitude: Number(loc.lng),
          }
        : {},
    })
    setPropertyData(null)
    setLoader(false)
    pause()
    setSelectedImages(selectedImages)
    setImages([])
    setEdit(false)
    handleOpenVerifyComp()
    handleCloseAddCompAddress()
  }

  const [potential, setPotential] = useState(false)

  const openEdit = (comp) => {
    if (props.public || props.shared) return
    setCompPropertyInput({
      mainProperty: comp._id,
      address: comp.address,
      city: comp.city,
      state: comp.state,
      zip: comp.zip,
      beds: comp.beds,
      baths: comp.baths,
      sqft: comp.sqft,
      year: comp.year,
      estval: comp.estval,
      priceAdjustment: comp.priceAdjustment,
      daysOnMarket: comp.daysOnMarket,
      rehabLevel: comp.rehabLevel,
      propertyType: comp.propertyType,
      status: comp.status,
      saleDate: comp.saleDate,
      indexTest: comp.indexTest,
      potential: comp.potential,
    })
    setPropertyData(null)
    setImages(comp.images || [])
    setSelectedImages([])
    setEdit(true)
    setPotential(comp.potential)
    handleOpenAddComp()
  }

  const reloadImages = () => {
    setSelectedImages([...selectedImages])
  }

  useEffect(() => {
    const comp = find(
      props.comps,
      (comp) => comp._id === compPropertyInput.mainProperty,
    )
    if (comp) {
      if (!isEqual(images, comp.images)) setImages(comp.images || [])
      setSelectedImages([])
    }
  }, [props.comps])

  const addImages = (files) => {
    let newSelectedImages = selectedImages
    newSelectedImages.push(files)
    setSelectedImages(newSelectedImages)
    reloadImages()
    enqueueSnackbar(`Image uploaded`, {
      variant: 'success',
      autoHideDuration: 3000,
    })
  }

  const activeOrg = property?.portfolio?.organization

  const {
    // acceptedFiles,
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
    },
    onDrop: async (acceptedFiles) => {
      // setFiles(acceptedFiles.map(file => Object.assign(file, {
      //   preview: URL.createObjectURL(file)
      // })));

      if (edit) {
        await Promise.all(
          map(acceptedFiles, (file) => {
            const reader = new FileReader()
            return new Promise((resolve, reject) => {
              reader.onload = async () => {
                const image = reader.result
                await imageUpload({
                  variables: {
                    documentId: compPropertyInput.mainProperty,
                    imageUrls: [image],
                    collection: 'compProperty',
                  },
                  refetchQueries: [
                    {
                      query: GET_COMPPROPERTIES,
                      variables: { propertyId: property._id },
                    },
                    {
                      query: GET_PROPERTY,
                      variables: { id: property._id },
                    },
                  ],
                }).then(async ({ data  }) => {
                  // enqueueSnackbar('Image Saved', {
                  //   variant: 'success',
                  //   autoHideDuration: 3000,
                  // })
                  // if (props.handleUpdateMarket) props.handleUpdateMarket()
                  resolve(image)
                })
              }
              reader.readAsDataURL(file)
            })
          }),
        )
        enqueueSnackbar(`Image uploaded`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
      } else {
        map(acceptedFiles, (file) => {
          loadImage(
            file,
            (img) => {
              addImages(img.toDataURL(file.type))
            },
            {
              orientation: true,
              canvas: true,
            },
          )
        })
      }
    },
  })

  // const files = acceptedFiles.map(file => (
  //   <ListItem key={file.path}>
  //     <span>{file.path}</span> <span>{file.size} bytes</span>
  //   </ListItem>
  // ));

  usePlaceAutocomplete(
    'autocomplete',
    {
      types: ['geocode'],
      placeholder: 'Search Property',
      onPlaceChanged: (place) => {
        setPlaceResult(place?.address_components ? place : null)
      },
    },
    openAddCompAddress,
  )

  const handleCompChange = (event) => {
    const { name = '', value = '' } = event.target
    console.log(name, value)
    let newInput = { ...compPropertyInput }
    let newValue = value
    //if (type === 'number') newValue = Number(value)
    newInput[name] = newValue
    console.log(newInput)
    setCompPropertyInput(newInput)
  }

  const onChangeDate = (date) => {
    let newInput = { ...compPropertyInput }
    newInput['saleDate'] = date
    setCompPropertyInput(newInput)
  }

  const onChangeSlider = (event, value, name) => {
    let newInput = { ...compPropertyInput }
    newInput[name] = value
    setCompPropertyInput(newInput)
  }

  const onChangeDateMenu = (date) => {
    // Ensure date is properly formatted to remove any potential time zone issues
    let newDate = date instanceof Date ? date : new Date(date)

    if (!isNaN(newDate)) {
      const formattedDate = newDate
        .toISOString()
        .substring(0, 10)
        .replace(/-/g, '')
      const year = Number(formattedDate.substring(0, 4))
      const month = Number(formattedDate.substring(4, 6))
      const day = Number(formattedDate.substring(6, 8))
      newDate = new Date(year, month - 1, day)

      // Call the onChangeDate with the new date
      onChangeDate(newDate)
    }
  }

  const renderInput = (field) => {
    if (field.display) {
      return (
        <Grid
          size={{
            xs: field.xs,
            sm: field.sm,
            md: field.md,
            lg: field.lg,
            xl: field.xl,
          }}
          container
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid>
            <Typography>{field.label}</Typography>
          </Grid>
          <Grid>
            <Typography>
              {field.type === 'dollar'
                ? currencyFormat.format(field.value) || '-'
                : field.value || '-'}
              {field.type === 'percentage' ? '%' : ''}
            </Typography>
          </Grid>
        </Grid>
      )
    } else if (field.type === 'date') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <DatePicker
            name={field.name}
            label={field.label}
            value={field.value ? new Date(field.value) : null} // Convert ISO string to Date object
            onChange={(date) => onChangeDate(date)}
            format="MM/dd/yyyy"
            slotProps={{
              textField: {
                variant: 'outlined',
                margin: 'dense',
                fullWidth: true,
                style: { borderColor: 'grey' },
                slotProps: {
                  inputLabel: { shrink: true },
                  input: {
                    endAdornment:
                      field.definition &&
                      propertyData &&
                      propertyData[field.definition] &&
                      propertyData[field.definition].length > 1 ? (
                        <InputAdornment
                          position="end"
                          onClick={(event) =>
                            handleDefinition(
                              field.definition,
                              event.target,
                              field.name,
                              field.format,
                            )
                          }
                        >
                          <IconButton
                            size="small" sx={strategyPad5Sx}>
                            <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                  },
                },
              },
            }}
            views={['year', 'month', 'day']}
            openTo="year"
          />
        </Grid>
      )
    } else if (field.type === 'select') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <Autocomplete
            id="autocomplete"
            value={field.value}
            options={field.options}
            onChange={(event, newValue) =>
              handleCompChange({
                target: { name: field.name, value: newValue },
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={field.label}
                variant="outlined"
              />
            )}
          />
        </Grid>
      )
    } else if (field.type === 'currency') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <NumericFormat
            customInput={TextField}
            thousandSeparator={true}
            prefix={'$'}
            fullWidth={true}
            //isNumericString={true}
            decimalScale={0}
            key={field.name}
            name={field.name}
            value={Math.round(field.value)}
            onValueChange={(values) => {
              const { value } = values
              const event = {
                target: {
                  name: field.name,
                  value: value,
                  type: 'number',
                },
                preventDefault: () => {
                  return null
                },
              }
              handleCompChange(event)
            }}
            type={'text'}
            onFocus={(event) => {
              event.target.select()
            }}
            variant="outlined"
            //margin='dense'
            label={field.label}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    } else if (field.type === 'number') {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <NumericFormat
            customInput={TextField}
            thousandSeparator={!field.noSeperator}
            fullWidth={true}
            //isNumericString={true}
            decimalScale={field.decimal || 0}
            key={field.name}
            name={field.name}
            value={field.value}
            allowNegative={false}
            onValueChange={(values) => {
              const { value } = values
              const event = {
                target: {
                  name: field.name,
                  value: value,
                  type: 'number',
                },
                preventDefault: () => {
                  return null
                },
              }
              handleCompChange(event)
            }}
            type={'text'}
            onFocus={(event) => {
              event.target.select()
            }}
            variant="outlined"
            //margin='dense'
            label={field.label}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    } else {
      return (
        <Grid size={{ xs: field.xs, sm: field.sm }}>
          <TextField
            name={field.name}
            fullWidth={true}
            variant="outlined"
            // margin='dense'
            label={field.label}
            value={field.value}
            onChange={handleCompChange}
            slotProps={{
              input: {
                endAdornment:
                  field.definition &&
                  propertyData &&
                  propertyData[field.definition] &&
                  propertyData[field.definition].length > 1 ? (
                    <InputAdornment
                      position="end"
                      onClick={(event) =>
                        handleDefinition(
                          field.definition,
                          event.target,
                          field.name,
                          field.format,
                        )
                      }
                    >
                      <IconButton size="small" sx={strategyPad5Sx}>
                        <FontAwesomeIcon icon={['fas', 'database']} sx={{ fontSize: "1.265rem !important" }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              },
            }}
          />
        </Grid>
      )
    }
  }

  const [addComp] = useMutation(ADD_COMPPROPERTY)
  const [addComps] = useMutation(ADD_COMPPROPERTIES)
  const [updateComp] = useMutation(UPDATE_COMPPROPERTY)
  const [updateComps] = useMutation(UPDATE_COMPPROPERTIES)
  const [deleteComp] = useMutation(DELETE_COMP)
  const [deleteComps] = useMutation(DELETE_COMP_MULTI)
  const [imageUpload] = useMutation(IMAGE_UPLOAD)
  const [imageUploadMulti] = useMutation(IMAGE_UPLOAD_MULTI)
  const [saveAnalysis] = useMutation(SAVE_ANALYSIS)
  const [deleteFile] = useMutation(DELETE_IMAGE)
  const [openDeleteComp, setOpenDeleteComp] = useState(false)

  const imageUploader = (
    propertyImagePairs,
    collection,
    first = false,
  ) => {
    imageUploadMulti({
      variables: {
        propertyImagePairs,
        collection,
        first,
      },
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: { propertyId: property._id },
        },
        {
          query: GET_PROPERTY,
          variables: { id: property._id },
        },
      ],
    })
  }

  const [anchorElActionsMenu, setAnchorElActionsMenu] = useState(null)
  const handleClickActionsMenu = (event) => {
    setAnchorElActionsMenu(event.currentTarget)
  }
  const handleCloseActionsMenu = () => {
    setAnchorElActionsMenu(null)
  }

  const toggleDeleteComp = () => {
    setOpenDeleteComp(!openDeleteComp)
  }

  const submitComp =
    (changePotential = false) =>
    () => {
      setLoader(true)
      if (edit) {
        updateComp({
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: {
                propertyId: property._id,
              },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
          variables: {
            id: compPropertyInput.mainProperty, //edit had id stored as mainProperty
            compPropertyInput: {
              address: compPropertyInput.address,
              city: compPropertyInput.city,
              state: compPropertyInput.state,
              zip: padStart(compPropertyInput.zip, 5, '0'),
              beds: parseInt(compPropertyInput.beds),
              baths: parseFloat(compPropertyInput.baths),
              sqft: parseFloat(compPropertyInput.sqft),
              year: parseInt(compPropertyInput.year),
              estval: parseInt(compPropertyInput.estval),
              daysOnMarket: parseInt(compPropertyInput.daysOnMarket),
              rehabLevel: compPropertyInput.rehabLevel,
              propertyType: compPropertyInput.propertyType,
              status: compPropertyInput.status,
              saleDate: compPropertyInput.saleDate
                ? new Date(compPropertyInput.saleDate)
                : null,
              //rentalPrice: parseFloat(rentalPrice),
              priceAdjustment: parseFloat(
                compPropertyInput.priceAdjustment,
              ),
              potential: changePotential ? !potential : potential,
            },
          },
        })
          .then(async ({ data  }) => {
            imageUpload({
              refetchQueries: [
                {
                  query: GET_COMPPROPERTIES,
                  variables: { propertyId: property._id },
                },
                {
                  query: GET_PROPERTY,
                  variables: { id: property._id },
                },
              ],
              variables: {
                documentId: compPropertyInput.mainProperty,
                imageUrls: selectedImages,
                collection: 'compProperty',
              },
            })

            enqueueSnackbar(`Comp updated successfully`, {
              variant: 'success',
              autoHideDuration: 3000,
            })
            handleCloseAddComp()
          })
          .catch((error) => {
            enqueueSnackbar(
              `We couldn't update your comp at this time`,
              {
                variant: 'error',
                autoHideDuration: 3000,
              },
            )
            handleCloseAddComp()
          })
      } else {
        addComp({
          awaitRefetchQueries: true,
          refetchQueries: [
            {
              query: GET_COMPPROPERTIES,
              variables: {
                propertyId: property._id,
              },
            },
            {
              query: GET_PROPERTY,
              variables: { id: property._id },
            },
          ],
          variables: {
            compPropertyInput: {
              mainProperty: compPropertyInput.mainProperty,
              address: compPropertyInput.address,
              city: compPropertyInput.city,
              state: compPropertyInput.state,
              zip: toString(padStart(compPropertyInput.zip, 5, '0')),
              beds: parseInt(compPropertyInput.beds),
              baths: parseFloat(compPropertyInput.baths),
              sqft: parseFloat(compPropertyInput.sqft),
              year: parseInt(compPropertyInput.year),
              estval: parseInt(compPropertyInput.estval),
              daysOnMarket: parseInt(compPropertyInput.daysOnMarket),
              rehabLevel: compPropertyInput.rehabLevel,
              propertyType: compPropertyInput.propertyType,
              status: compPropertyInput.status,
              saleDate: compPropertyInput.saleDate
                ? new Date(compPropertyInput.saleDate)
                : null,
              //rentalPrice: parseFloat(rentalPrice),
              priceAdjustment: parseFloat(
                compPropertyInput.priceAdjustment,
              ),
              location: compPropertyInput.location,
            },
          },
        })
          .then(async ({ data  }) => {
            imageUpload({
              refetchQueries: [
                {
                  query: GET_COMPPROPERTIES,
                  variables: { propertyId: property._id },
                },
              ],
              variables: {
                documentId: data.addCompProperty._id,
                imageUrls: selectedImages,
                collection: 'compProperty',
              },
            })
            enqueueSnackbar(`Comp added successfully`, {
              variant: 'success',
              autoHideDuration: 3000,
            })

            handleCloseAddCompAddress()
            handleCloseVerifyComp()
            handleCloseFixComp()
            openEdit(data.addCompProperty)
          })
          .catch((error) => {
            enqueueSnackbar(
              `We couldn't add your comp at this time`,
              {
                variant: 'error',
                autoHideDuration: 3000,
              },
            )
            handleCloseAddCompAddress()
            handleCloseVerifyComp()
            handleCloseFixComp()
          })
      }
    }

  const onDelete = () => {
    deleteComp({
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: {
            propertyId: property._id,
          },
        },
        {
          query: GET_PROPERTY,
          variables: { id: property._id },
        },
      ],
      variables: {
        id: compPropertyInput.mainProperty, //edit stores _id as mainProperty
      },
    })
      .then(async ({ data  }) => {
        enqueueSnackbar(`Comp Deleted`, {
          variant: 'success',
          autoHideDuration: 3000,
        })
        handleCloseAddComp()
        toggleDeleteComp()
      })
      .catch((error) => {
        enqueueSnackbar(`Error Deleting Comp`, {
          variant: 'error',
          autoHideDuration: 3000,
        })
        handleCloseAddComp()
        toggleDeleteComp()
      })
  }

  const checkForRealeflowDups = () => {
    const selectedAddressHashs = map(
      filter(results?.data?.getRealeflowCompData, (data) => {
        const { property } = data
        return includes(realeflowIncludedIds, property?._id)
      }),
      (comp) => comp?.property?.address_hash,
    )
    const duplicateIds = compact(
      map(
        filter(props.comps, (comp) => {
          return includes(selectedAddressHashs, comp?.addressHash)
        }),
        (comp) => comp._id,
      ),
    )
    if (isEmpty(realeflowIncludedIds)) {
      setOpenNoCompWarning(true)
    } else if (isEmpty(duplicateIds)) {
      importRealeflowComps()
    } else {
      setDuplicateComps(duplicateIds)
      setOpenDuplicateWarning(true)
    }
  }

  const deleteDuplicates = () => {
    deleteComps({
      variables: {
        ids: duplicateComps,
      },
    }).then(() => {
      setDuplicateComps([])
    })
  }

  const importRealeflowComps = () => {
    setLoader(true)
    const selectedComps = filter(
      results?.data?.getRealeflowCompData,
      (data) => {
        const { property } = data
        return includes(realeflowIncludedIds, property?._id)
      },
    )

    const mainPropertyId = property._id

    const compPropertyInputs = map(selectedComps, (comp) => {
      const { property } = comp
      const address =
        property?.mailing_std_full_street_address ||
        property?.address_number +
          ' ' +
          property?.address_direction_pre +
          ' ' +
          property?.address_street +
          ' ' +
          property?.address_direction_post +
          ' ' +
          (property?.address_suffix || '')
      return {
        mainProperty: mainPropertyId,
        address: address,
        city: property?.address_city,
        state: property?.address_state,
        zip: toString(padStart(property?.address_zip, 5, '0')),
        beds: parseInt(property?.bedrooms),
        baths: parseFloat(property?.bath_total_calc),
        sqft: parseFloat(property?.building_area),
        year: parseInt(property?.effective_year_built),
        estval: parseInt(property?.property_value),
        // daysOnMarket: parseInt(compPropertyInput.daysOnMarket),
        // rehabLevel: compPropertyInput.rehabLevel,
        status: property?.MLS_Curr_Status,
        propertyType: property?.LookupCodes?.PropertyType,
        saleDate: property?.status_info?.date_sold
          ? new Date(
              readRealeflowDateString(
                property?.status_info?.date_sold,
              ),
            )
          : null,
        //rentalPrice: parseFloat(rentalPrice),
        // priceAdjustment: parseFloat(
        //   0,
        // ),
        location: {
          latitude: property?.location?.lat,
          longitude: property?.location?.lon,
        },
        realeflowData: property,
        addressHash: property?.address_hash,
      }
    })
    addComps({
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: {
            propertyId: property._id,
          },
        },
        {
          query: GET_PROPERTY,
          variables: { id: property._id },
        },
      ],
      variables: {
        compPropertyInputs,
      },
    })
      .then(async ({ data  }) => {
        enqueueSnackbar(`Comps added successfully`, {
          variant: 'success',
          autoHideDuration: 3000,
        })

        const MAP_KEY = googleApiKey

        let propertyImagePairs = compact(
          await Promise.all(
            map(data?.addCompProperties, async (comp) => {
              const { latitude, longitude } = comp?.location
              let images = []
              if (latitude && longitude) {
                await new Promise((resolve, reject) => {
                  try {
                    var service = window.google
                      ? new window.google.maps.StreetViewService()
                      : 0
                    if (service !== 0) {
                      service.getPanoramaByLocation(
                        {
                          lat: Number(latitude),
                          lng: Number(longitude),
                        },
                        50,
                        function (panoData) {
                          if (panoData !== null) {
                            var ManLatLng = panoData.location.latLng
                            const heading =
                              window.google.maps.geometry.spherical.computeHeading(
                                ManLatLng,
                                new window.google.maps.LatLng(
                                  Number(latitude),
                                  Number(longitude),
                                ),
                              )
                            images.push(
                              `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${latitude},${longitude}&heading=${heading}&key=${MAP_KEY}`,
                            )
                          }
                          resolve()
                        },
                      )
                    } else resolve()
                  } catch (error) {
                    console.log(error)
                  }
                })
                images.push(
                  `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&size=400x400&markers=color:blue%7C${latitude},${longitude}&key=${MAP_KEY}`,
                )
              }

              if (!isEmpty(images)) {
                return {
                  propertyId: comp?._id,
                  imageUrls: images || [],
                }
              }
            }),
          ),
        )

        imageUploader(propertyImagePairs, 'compProperty', false)

        handleFindMenuClose()
      })
      .catch((error) => {
        enqueueSnackbar(`We couldn't add your comps at this time`, {
          variant: 'error',
          autoHideDuration: 3000,
        })
        handleFindMenuClose()
      })
  }

  const realeflowTableHeaders = [
    { title: 'Address', name: 'property.address_number' },
    {
      title: 'Distance',
      name: 'distance',
      formatter: (x) => round(x, 2),
    },
    { title: 'Beds', name: 'property.bedrooms' },
    { title: 'Baths', name: 'property.bath_full' },
    {
      title: 'Sold Price',
      name: 'property.status_info.price_sold',
      formatter: (x) => currencyFormat.format(x),
    },
    {
      title: 'Sold Date',
      name: 'property.status_info.date_sold',
      formatter: (x) => formatDateYmd(readRealeflowDateString(x)),
    },
    { title: 'Rent Est', name: 'property.rentEst' },
    { title: 'AVM', name: 'property.avm' },
    {
      title: 'SqFt',
      name: 'property.sum_building_sq_ft',
      formatter: (x) => {
        const difference = x - Number(property.sqft)
        return (
          <>
            <Typography>{numberFormat.format(x)}</Typography>
            <Typography>
              ({difference > 0 ? '+' : '-'}
              {Math.abs(difference) })
            </Typography>
          </>
        )
      },
    },
    { title: 'Year Built', name: 'property.effective_year_built' },
  ]

  const compAddressFields = [
    {
      type: 'text',
      name: 'address',
      label: 'Address',
      value: compPropertyInput.address,
      definition: 'address',
      xs: 12,
    },
    {
      type: 'text',
      name: 'city',
      label: 'City',
      value: compPropertyInput.city,
      definition: 'city',
      xs: 12,
    },
    {
      type: 'autocomplete',
      name: 'state',
      label: 'State',
      options: statesShort(),
      value: compPropertyInput.state,
      definition: 'state',
      xs: 6,
    },
    {
      type: 'number',
      name: 'zip',
      label: 'Zip',
      value: compPropertyInput.zip,
      definition: 'zip',
      noSeperator: true,
      xs: 6,
    },
  ]

  const compDetailFields = [
    {
      type: 'number',
      name: 'beds',
      label: 'Beds',
      value: compPropertyInput.beds,
      definition: 'beds',
      xs: 6,
    },
    {
      type: 'number',
      name: 'baths',
      label: 'Baths',
      value: compPropertyInput.baths,
      definition: 'baths',
      decimal: 2,
      xs: 6,
    },
    {
      type: 'number',
      name: 'sqft',
      label: 'Sqft',
      value: compPropertyInput.sqft,
      definition: 'sqft',
      format: numberFormat,
      xs: 6,
    },
    {
      type: 'number',
      name: 'year',
      label: 'Year',
      noSeperator: true,
      value: compPropertyInput.year,
      definition: 'yearBuilt',
      xs: 6,
    },
  ]

  const compFields = concat(compAddressFields, compDetailFields)

  const compFinancialFields = [
    {
      type: 'currency',
      name: 'estval',
      label: 'Sold Price',
      value: compPropertyInput.estval,
      definition: 'price',
      format: currencyFormat,
      xs: 12,
      sm: 6,
    },
    {
      type: 'date',
      name: 'saleDate',
      label: 'Date Sold',
      value: compPropertyInput.saleDate
        ? new Date(compPropertyInput.saleDate).toLocaleDateString(
            'en-US',
          )
        : null,
      definition: 'soldDate',
      xs: 12,
      sm: 6,
    },
    {
      type: 'number',
      name: 'daysOnMarket',
      label: 'Days on Market',
      value: compPropertyInput.daysOnMarket,
      xs: 12,
      sm: 6,
    },
    {
      type: 'select',
      name: 'rehabLevel',
      label: 'Rehab Level',
      value: compPropertyInput.rehabLevel,
      xs: 12,
      sm: 6,
      options: map(REHAB_LEVELS, (rehab) => rehab.value),
    },
    {
      type: 'text',
      name: 'propertyType',
      label: 'Property Type',
      value: compPropertyInput.propertyType,
      xs: 12,
      sm: 6,
    },
    {
      type: 'select',
      name: 'status',
      label: 'Status',
      value: compPropertyInput.status,
      xs: 12,
      sm: 6,
      options: ['Sold', 'Active', 'Pending'],
    },
  ]

  const widgetsCarousels1B = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
  }

  const [selected, setSelected] = useState([])

  const [search, setSearch] = useState('')
  const [searchedComps, setSearchedComps] = useState(comps)

  const [filtered, setFiltered] = useState(false)
  const [filteredComps, setFilteredComps] = useState(comps)

  const [showMap, setShowMap] = useState(false)
  const [showAnalytics, setShowAnalytics] = useState(false)

  const [path, setPath] = useState([])
  const [openSelectedDrawing, setOpenSelectedDrawing] =
    useState(false)
  const [selectedDrawing, setSelectedDrawing] = useState([])

  const compDrawingCallback = (polygon) => {
    const excludedComps = filter(comps, (comp) => {
      const loc = comp.location || {}
      const point = new window.google.maps.LatLng({
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      })

      const isInside = window.google.maps.geometry
        ? window.google.maps.geometry.poly.containsLocation(
            point,
            polygon,
          )
        : false

      return !isInside
    })
    setSelectedDrawing(map(excludedComps, (comp) => comp._id))
    setOpenSelectedDrawing(true)
  }

  const handleExcludedComps = (potential = false) => {
    setLoader(true)
    if (potential) {
      updateComps({
        variables: {
          ids: selectedDrawing,
          compPropertyInput: { potential },
        },
        refetchQueries: [
          {
            query: GET_COMPPROPERTIES,
            variables: { propertyId: property._id },
          },
        ],
      }).then(async ({ data  }) => {
        setLoader(false)
        setSelectedDrawing([])
        setOpenSelectedDrawing(false)
      })
    } else {
      deleteComps({
        variables: {
          ids: selectedDrawing,
          compPropertyInput: { potential },
        },
        refetchQueries: [
          {
            query: GET_COMPPROPERTIES,
            variables: { propertyId: property._id },
          },
        ],
      }).then(async ({ data  }) => {
        setLoader(false)
        setSelectedDrawing([])
        setOpenSelectedDrawing(false)
      })
    }
  }

  const [searchStatus3, setSearchStatus3] = useState(false)
  const toggleSearch3 = () => setSearchStatus3(!searchStatus3)

  const { page, setPage } = props
  const handleChange = (event, value) => {
    localStorage.setItem(
      `${property._id}-comps-actual-card-page`,
      value,
    )
    setPage(value)
  }

  const { potentialPage, setPotentialPage } = props
  const handlePotentialChange = (event, value) => {
    localStorage.setItem(
      `${property._id}-comps-potential-card-page`,
      value,
    )
    setPotentialPage(value)
  }

  const [bulkSetCompDialog, setBulkSetCompDialog] = useState(false)
  const [bulkSetPotentialDialog, setBulkSetPotentialDialog] =
    useState(false)

  const handleBulkDialog = (potential = false) => {
    setLoader(true)
    updateComps({
      variables: {
        ids: selected,
        compPropertyInput: { potential },
      },
      refetchQueries: [
        {
          query: GET_COMPPROPERTIES,
          variables: { propertyId: property._id },
        },
      ],
    }).then(async ({ data  }) => {
      setLoader(false)
      setSelected([])
      closeBulk()
    })
  }

  const closeBulk = () => {
    setBulkSetCompDialog(false)
    setBulkSetPotentialDialog(false)
  }

  let shownComps =
    search && filtered
      ? intersectionBy(searchedComps, filteredComps, '_id')
      : search
        ? [...searchedComps]
        : filtered && filteredComps
          ? [...filteredComps]
          : [...comps] || []

  let unfilteredComps = cloneDeep(comps)
  let unfilteredPotentialComps = remove(
    unfilteredComps,
    (comp) => comp.potential,
  )

  let potentialComps = remove(shownComps, (comp) => comp.potential)
  // const potentialCompID = map(potentialComps, comp => comp._id)
  // const potentialSelected = every(selected, id => includes(potentialCompID, id))

  const potentialSelected =
    filter(potentialComps, (comp) => includes(selected, comp._id))
      .length > 0
  const actualSelected =
    filter(shownComps, (comp) => includes(selected, comp._id))
      .length > 0

  const shownCompID = map(shownComps, (comp) => comp._id)
  const shownCompValues = filter(compValues, (value) =>
    includes(shownCompID, value._id),
  )

  const allShownComps = concat(shownComps, potentialComps)
  const selectAllComps =
    alignment === 'potential' ? potentialComps : shownComps
  const compare = intersection(
    map(selectAllComps, (comp) => comp._id),
    selected,
  )

  const selectComp = (id) => (event) => {
    event.preventDefault()
    let newSelect = [...selected]
    if (includes(newSelect, id)) pull(newSelect, id)
    else newSelect.push(id)
    setSelected(newSelect)
  }

  const selectAll = () => {
    if (compare.length < selectAllComps.length)
      setSelected(map(selectAllComps, (comp) => comp._id))
    else setSelected([])
  }

  const [filterReset, setFilterReset] = useState(null)
  const [isSavedFilter, setIsSavedFilter] = useState(false)

  const getFilteredComps = (filtered) => {
    setFilteredComps(filtered)
    setFiltered(true)
  }

  useEffect(() => {
    const getSearchResults = (string) => {
      if (search === string) return null
      const words = split(string, ' ')
      const searchFilters = map(
        words,
        (word) => new RegExp(toLower(word)),
      )
      const filtered = filter(comps, (comp) => {
        const { createdBy } = comp
        const profile = createdBy
          ? createdBy.profile
          : { firstname: '', lastname: '' }
        return every(
          searchFilters,
          (searchFilter) =>
            searchFilter.test(toLower(comp.address)) ||
            searchFilter.test(toLower(comp.city)) ||
            searchFilter.test(toLower(comp.state)) ||
            searchFilter.test(toLower(comp.zip)) ||
            searchFilter.test(toLower(comp.sqft)) ||
            searchFilter.test(toLower(comp.description)) ||
            searchFilter.test(toLower(profile.firstname)) ||
            searchFilter.test(toLower(profile.lastname)),
        )
      })
      if (isEqual(filtered, searchedComps)) return null
      setSearch(string)
      setSearchedComps(filtered)
    }
    getSearchResults(search)
  }, [comps, search, searchedComps])

  const count = ceil(shownComps.length / 24)
  if (page > count && count) setPage(count || 1)

  const potentialCount = ceil(potentialComps.length / 24)
  if (potentialPage > potentialCount && potentialCount)
    setPage(potentialCount || 1)

  React.useEffect(() => {
    let photos = map(concat(selectedImages, images), (image) => ({
      id: image._id,
      src: image.url,
      url_small: image.url_small,
      width: 4,
      height: 3,
    }))
    setItems(photos)
  }, [images, selectedImages])

  const onSortEnd = ({ oldIndex, newIndex  }) => {
    if (props.shared) return
    else {
      const newOrder = arrayMove(items, oldIndex, newIndex)
      setItems(newOrder)
      updateComp({
        variables: {
          id: compPropertyInput.mainProperty,
          compPropertyInput: {
            imageOrder: map(newOrder, (item) => item.id),
          },
        },
      }).then(({ data  }) => {
        const { updateCompProperty } = data
        setImages(updateCompProperty.images)
      })
    }
  }

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={[strategyPagePadSx, { width: '100%', maxWidth: '100%', minWidth: 0 }]}
      >
        <Grid size={12} data-hf-grid="keep">
          <Grid
            container
            direction="row"
            //
            spacing={2}
            sx={{
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid data-hf-grid="keep">
              {!props.public && !props.shared && (
                <>
                  <Grid>
                    <Button
                      data-tour="comps-step-3"
                      variant="contained"
                      size="small"
                      //onClick={handleMenuOpen}
                      onClick={
                        props.session &&
                        props.session.me &&
                        props.session.me.activeOrg &&
                        props.session.me.activeOrg.isRealeflow &&
                        property?.realeflowData
                          ? handleMenuOpen
                          : handleOpenAddCompAddress
                      } sx={{
                        backgroundColor: '#1cc943',
                        color: 'white',
                      }}>
                      <AddTwoToneIcon
                        /**/ sx={strategyMarginRight10Sx}/>
                      Add Comp
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
            {!showMenu && (
              <Grid data-hf-grid="keep">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        onClick={() => {
                          setShowMenu(!showMenu)
                        }}
                        size="small"
                        defaultChecked
                      />
                    }
                    label="Show Menu"
                  />
                </FormGroup>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid size={12}>
          <Collapse
            in={Boolean(showMenu)}
            sx={{
              width: '100%',
              mb: 2,
            }}
          >
            <Card variant="outlined"
              sx={{
              display: 'block',
              textAlign: 'center',
              '@media (min-width: 576px)': { display: 'flex' },
              '@media (min-width: 768px)': { textAlign: 'left' },
              p: '1.5rem',
              alignItems: 'center',
              backgroundColor: '#f8f9ff',
              justifyContent: 'space-between',
              flexDirection: 'row',
              width: '100%',
              maxWidth: '100%',
              }}
              >
              {hiddenUp ? null : (
                <div
                  sx={strategyPositionCloseSx}
                >
                  <Typography
                    variant="subtitle2"
                    onClick={() => handleMenu()}
                  >
                    Hide Menu
                  </Typography>
                </div>
              )}
              <Grid
                container
                spacing={1}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  alignItems: "center",
                  rowGap: 1,
                }}
              >
                <Grid size="auto">
                  {!props.shared && (
                    <Grid
                      container
                      sx={{
                        alignItems: 'center',
                      }}
                    >
                      <Grid>
                        <Checkbox
                          checked={compare.length > 0}
                          indeterminate={
                            compare.length < selectAllComps.length &&
                            compare.length > 0
                          }
                          onClick={selectAll}
                        />
                      </Grid>
                      <Grid>
                        <ToggleButtonGroup
                          color="primary"
                          value={alignment}
                          exclusive
                          onChange={toggleAlignment}
                          aria-label="Platform"
                          sx={{ mr: '1rem' }}
                          >
                          <ToggleButton value="actual">
                            Actual ({shownComps?.length })
                          </ToggleButton>
                          <ToggleButton value="potential">
                            Potential ({potentialComps?.length })
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {!props.shared && (
                  <Grid size="auto" sx={{
                    display: "none",
                    "@media (min-width: 576px)": { display: "block" },
                    alignSelf: "stretch",
                    width: "1px",
                    minHeight: 26,
                    mx: "1rem",
                    bgcolor: "#4f5062",
                    opacity: 0.3,
                    flexShrink: 0,
                  }} />
                )}
                <Box
                  sx={[
                    {
                      position: "relative",
                      flex: "1 1 160px",
                      minWidth: 140,
                      maxWidth: 280,
                      "& .MuiTextField-root": { width: "100%", maxWidth: "100%" },
                    },
                    {
                      display: 'flex',
                      justifyContent: 'center',
                      py: { xs: '1rem', md: 0 },
                    },
                  ]}
                >
                  <Box
                    sx={[
                      {
                        position: "relative",
                        transition: "all 0.2s ease-in-out",
                        "& .MuiOutlinedInput-notchedOutline": { borderWidth: 2 },
                        "& .MuiTextField-root": { borderWidth: 2, transition: "all 0.2s ease-in-out", background: "#f8f9ff" },
                        "&:hover .MuiTextField-root": { background: "#f4f5fd" },
                        "&.is-active .MuiTextField-root": { background: "#fff", borderColor: "#368cff" },
                      },
                      {
                        width: '100%',
                        '& .MuiTextField-root': {
                          width: '100%',
                          maxWidth: '100%',
                        },
                      },
                    ]}
                  >
                    <TextField
                      variant="outlined"
                      size="small"
                      sx={{ backgroundColor: "#fff" }}
                      value={props.search}
                      onChange={(event) =>
                        setSearch(event.target.value)
                      }
                      placeholder={'Search these comps'}
                      id="input-with-icon-textfield22-3"
                      onFocus={toggleSearch3}
                      onBlur={toggleSearch3}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <FontAwesomeIcon
                                icon={['fas', 'search']}
                                sx={strategyMutedGraySx}
                              />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </Box>
                </Box>
                {activeTab === '1' && (
                  <Grid
                    size="auto"
                    sx={{ ml: 'auto', mr: 0.5, flexShrink: 0 }}
                  >
                    <Select
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={ordering}
                      onChange={(event) =>
                        setOrdering(event.target.value)
                      }
                      displayEmpty
                    >
                      {map(sortingChoices, (choice) => (
                        <MenuItem
                          key={choice.name}
                          value={choice.name}
                        >
                          {choice.title}
                        </MenuItem>
                      ))}
                      <MenuItem key={'unselected'} value={''}>
                        Added - new to old
                      </MenuItem>
                    </Select>
                  </Grid>
                )}
                <Grid
                  size="auto"
                  sx={{
                    flexShrink: 0,
                    ...(activeTab === '1' ? {} : { ml: 'auto'  }),
                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    wrap="nowrap"
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    {filterReset && (
                      <Grid>
                        <Chip
                          color={isSavedFilter ? 'primary' : 'grey'}
                          variant="outlined"
                          label="Filters Applied"
                          onDelete={filterReset}
                        />
                      </Grid>
                    )}
                    <Grid>
                      <ButtonGroup
                        variant="contained"
                        color="primary"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                          overflow: "hidden",
                          borderRadius: "0.2rem",
                          "& .MuiButton-root": {
                            minWidth: "40px !important",
                            width: 40,
                            height: 40,
                            p: 0,
                            backgroundImage: "none",
                            borderColor: "rgba(255,255,255,0.22) !important",
                            boxShadow: "none",
                          },
                          "& .MuiButton-root:not(.active)": {
                            color: "#fff",
                            backgroundColor: "#368cff",
                            "&:hover": { backgroundColor: "#368cff", color: "#fff" },
                            "& .MuiSvgIcon-root": { color: "#fff" },
                          },
                        }}
                      >
                        <Tooltip title="Card View">
                          <Button
                            onClick={() => {
                              setActiveTab('1')
                              localStorage.setItem('comp-view', '1')
                            }}
                            {...searchToolbarIconButtonProps(activeTab === '1')}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <GridOnTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                        <Tooltip title="List View">
                          <Button
                            onClick={() => {
                              setActiveTab('2')
                              localStorage.setItem('comp-view', '2')
                            }}
                            {...searchToolbarIconButtonProps(activeTab === '2')}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <ListIcon />
                            </Box>
                          </Button>
                        </Tooltip>
                      </ButtonGroup>
                    </Grid>
                    <Grid>
                      <ButtonGroup
                        variant="contained"
                        color="primary"
                        sx={{
                          boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                          overflow: "hidden",
                          borderRadius: "0.2rem",
                          "& .MuiButton-root": {
                            minWidth: "40px !important",
                            width: 40,
                            height: 40,
                            p: 0,
                            backgroundImage: "none",
                            borderColor: "rgba(255,255,255,0.22) !important",
                            boxShadow: "none",
                          },
                          "& .MuiButton-root:not(.active)": {
                            color: "#fff",
                            backgroundColor: "#368cff",
                            "&:hover": { backgroundColor: "#368cff", color: "#fff" },
                            "& .MuiSvgIcon-root": { color: "#fff" },
                          },
                        }}
                      >
                        <Tooltip title="Show Analytics">
                          <Button
                            onClick={() => {
                              setShowAnalytics(!showAnalytics)
                            }}
                            {...searchToolbarIconButtonProps(showAnalytics)}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <PollTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                        <Tooltip title="Show Map">
                          <Button
                            onClick={() => {
                              setShowMap(!showMap)
                            }}
                            {...searchToolbarIconButtonProps(showMap)}
                          >
                            <Box component="span" sx={[{
                              height: "20px !important",
                              width: "20px !important",
                              lineHeight: "20px !important",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }, { display: "inline-flex" }]}>
                              <RoomTwoTone />
                            </Box>
                          </Button>
                        </Tooltip>
                        <MyPropertiesFilter
                          openFilterDrawer={true}
                          comps={true}
                          properties={props.comps}
                          getFilteredProperties={getFilteredComps}
                          setFilterReset={setFilterReset}
                          setIsSavedFilter={setIsSavedFilter}
                          activeOrg={
                            props.session && props.session.me
                              ? props.session.me.activeOrg
                              : {}
                          }
                        />
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Collapse>
        </Grid>
        <Grid size={12}>
          <Grid container spacing={2}>
            {showMap && (
              <Grid size={{ xs: 12, xl: 6 }}>
                <Card>
                  {/* {!openAddCompAddress && (<Map properties={[property]} comps={shownComps} propertyPage streetView={false} />)} */}
                  <Map
                    properties={[property]}
                    comps={stableSort(
                      shownComps,
                      getSorting(order, orderByTarget),
                    )}
                    potentialComps={stableSort(
                      potentialComps,
                      getSorting(order, orderByTarget),
                    )}
                    streetView={false}
                    hide={openAddCompAddress}
                    openComp={openEdit}
                    shared={props.shared || props.public}
                    noInfoWindow
                    path={path}
                    setPath={setPath}
                    drawingCallback={compDrawingCallback}
                  />
                </Card>
              </Grid>
            )}
            {showAnalytics && (
              <Grid size={{ xs: 12, xl: 6 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Comps Properties
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[strategyIconBlueBgSx, {
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            borderRadius: "0.65rem",
                            flexShrink: 0,
                            color: "#fff",
                            textAlign: "center",
                            mr: "1rem",
                            boxShadow: "0 0.313rem 0.8rem rgba(65, 145, 255, 0.5), 0 0.126rem 0.225rem rgba(65, 145, 255, 0.3) !important",
                          }]}>
                            <HomeIcon sx={strategyIconSize40Sx} />
                          </Box>
                          <Box sx={[{ ml: '0.25rem' }, { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            {shownComps.length}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            color: 'rgba(7, 9, 25, 0.5)',
                            mb: '0.5rem',
                          }}
                        >
                          The number of properties comparable to{' '}
                          {property.address}.
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Adjusted Range
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[{ fontWeight: 700, ml: '0.25rem' }, { fontSize: "1.7rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : minBy(
                                      shownCompValues,
                                      'propertyPrice',
                                    ).propertyPrice / 1000
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                            <span> - </span>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : maxBy(
                                      shownCompValues,
                                      'propertyPrice',
                                    ).propertyPrice / 1000
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={1}
                              decimal="."
                              prefix="$"
                              suffix="k"
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            color: 'rgba(7, 9, 25, 0.5)',
                            mb: '0.5rem',
                          }}
                        >
                          The adjusted value range of the comp
                          properties below (in thousands)
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined"
                      data-tour="comps-step-1" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Avg. Adjusted Value
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[strategyIconBlueBgSx, {
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            borderRadius: "0.65rem",
                            flexShrink: 0,
                            color: "#fff",
                            textAlign: "center",
                            mr: "1rem",
                            boxShadow: "0 0.313rem 0.8rem rgba(65, 145, 255, 0.5), 0 0.126rem 0.225rem rgba(65, 145, 255, 0.3) !important",
                          }]}>
                            <LinearScaleIcon
                              sx={strategyIconSize40Sx}
                            />
                            {/* <FontAwesomeIcon
                            icon={['far', 'envelope']}
                          /> */}
                          </Box>
                          <Box sx={[{ fontWeight: 700, ml: '0.25rem' }, { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : meanBy(
                                      filter(
                                        shownCompValues,
                                        'propertyPrice',
                                      ),
                                      'propertyPrice',
                                    )
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={0}
                              decimal="."
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          color: 'rgba(7, 9, 25, 0.5)',
                          mb: '0.5rem',
                        }}
                      >
                        This number helps you to confirm the ARV of
                        the subject property
                      </Box>
                    </Card>
                  </Grid>
                  <Grid size={{ xs: 12, lg: 6 }}>
                    <Card variant="outlined" sx={[strategyFullHeight100Sx, { p: '1.5rem' }]}>
                      <Box sx={[{ textTransform: 'uppercase', mt: '0.5rem', }, { fontSize: "0.875rem !important" }, strategyDarkTextSx]}>
                        Avg. Adjusted price/sqft
                      </Box>
                      <Box sx={{ my: '0.5rem' }}>
                        <Box
                          sx={{
                            display: 'flex',
                            py: '1.5rem',
                            alignItems: 'center',
                          }}
                        >
                          <Box sx={[strategyIconBlueBgSx, {
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            borderRadius: "0.65rem",
                            flexShrink: 0,
                            color: "#fff",
                            textAlign: "center",
                            mr: "1rem",
                            boxShadow: "0 0.313rem 0.8rem rgba(65, 145, 255, 0.5), 0 0.126rem 0.225rem rgba(65, 145, 255, 0.3) !important",
                          }]}>
                            <SquareFootIcon
                              sx={strategyIconSize40Sx}
                            />
                          </Box>
                          <Box sx={[{ fontWeight: 700, ml: '0.25rem' }, { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]}>
                            <CountUp
                              start={0}
                              end={
                                isEmpty(shownCompValues)
                                  ? 0
                                  : meanBy(
                                      filter(
                                        shownCompValues,
                                        'propertyPerSqft',
                                      ),
                                      'propertyPerSqft',
                                    )
                              }
                              duration={1}
                              separator=","
                              delay={1}
                              decimals={2}
                              decimal="."
                              prefix="$"
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          color: 'rgba(7, 9, 25, 0.5)',
                          mb: '0.5rem',
                        }}
                      >
                        According to adjusted $/sqft, the subject
                        property's value is{' '}
                        <Box
                          component="span"
                          sx={{ fontWeight: 700 }}
                        >
                          {isEmpty(shownCompValues)
                            ? '-'
                            : currencyFormat.format(
                                meanBy(
                                  filter(
                                    shownCompValues,
                                    'propertyPerSqft',
                                  ),
                                  'propertyPerSqft',
                                ) * property.sqft || 0,
                              )}
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        {!isEmpty(comps) && (
          <Grid size={12} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
            {alignment === 'actual' && activeTab === '2' && (
              <Grid
                container
                direction="row"
                spacing={4}
                sx={{
                  justifyContent: 'center',
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                }}
              >
                {unfilteredComps.length > 0 ? (
                  compact(shownComps).length > 0 ? (
                    <CompsList
                      comps={map(
                        stableSort(
                          compact(shownComps),
                          getSorting(order, orderByTarget),
                        ),
                        (comp, index) => ({
                          ...comp,
                          mapIndex: index,
                        }),
                      )}
                      ordering={ordering}
                      property={property}
                      openEdit={openEdit}
                      selected={selected}
                      selectComp={selectComp}
                      selectAll={selectAll}
                      shared={props.shared || props.public}
                    />
                  ) : (
                    <Grid>
                      <AllPropertiesFiltered />
                    </Grid>
                  )
                ) : (
                  <Grid>
                    <Box sx={{ textAlign: 'center', p: '3rem' }}>
                      <Box sx={[{ borderRadius: '50%', m: 0 }, {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: "0.25rem",
                        position: "relative",
                        fontSize: "1.2rem",
                        transition: "all 0.2s ease-in-out",
                        "&:last-child": { mr: 0, marginRight: 0 },
                        "& .badge": { position: "absolute", right: 0, bottom: 0 },
                        "& svg, & .svg-inline--fa": { display: "block" },
                        marginRight: "0.25rem",
                      }]}>
                        <Box sx={[{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "130px !important",
                          width: "130px !important",
                          lineHeight: "130px !important",
                          p: 0,
                          borderRadius: "50%",
                          m: 0,
                        }, {
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: "0.25rem",
                          position: "relative",
                          fontSize: "1.2rem",
                          transition: "all 0.2s ease-in-out",
                          "&:last-child": { mr: 0, marginRight: 0 },
                          "& .badge": { position: "absolute", right: 0, bottom: 0 },
                          "& svg, & .svg-inline--fa": { display: "block" },
                          marginRight: "0.25rem",
                        }, strategyHighlightBlueSx]}>
                          <FontAwesomeIcon icon={['fas', 'house-chimney']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
                        </Box>
                      </Box>
                      <Box
                        component="h4"
                        sx={{ fontWeight: 700, mt: '1.5rem' }}
                      >
                        No Comps Found...
                      </Box>
                      <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                        This property has no comps
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
            {alignment === 'actual' && activeTab === '1' && (
              <>
                <Grid sx={{ mt: 2, mb: 1, overflow: 'visible' }}>
                  <Typography
                    variant="h5"
                    sx={{ lineHeight: 1.4, overflow: 'visible' }}
                  >
                    Comparable Properties
                  </Typography>
                </Grid>
                <Grid container>
                  {unfilteredComps.length > 0 ? (
                    compact(shownComps).length > 0 ? (
                      <>
                        <Grid
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 380px), 1fr))",
                            gap: 4,
                            width: "100%",
                            mt: "10px",
                          }}
                        >
                          {map(
                            slice(
                              stableSort(
                                compact(shownComps),
                                getSorting(order, orderByTarget),
                              ),
                              (page - 1) * 24,
                              page * 24,
                            ),
                            (comp, index) => (
                              <CompsCard
                                key={comp?._id || `shown-comp-${index}`}
                                organization={organization}
                                comp={comp}
                                index={(page - 1) * 24 + index}
                                property={property}
                                openEdit={openEdit}
                                selected={selected}
                                selectComp={selectComp}
                                shared={props.shared || props.public}
                              />
                            ),
                          )}
                        </Grid>
                        {Boolean(count) && shownComps.length > 0 && (
                          <Grid size={12}>
                            <Box
                              sx={{
                                p: '1rem',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              <Pagination size="small" count={count} page={page} onChange={handlePotentialChange} shared={props.shared || props.public} />
                            </Box>
                          </Grid>
                        )}
                      </>
                    ) : (
                      <Grid size={12}>
                        <AllPropertiesFiltered />
                      </Grid>
                    )
                  ) : (
                    <Grid size={12}>
                      <Box sx={{ textAlign: 'center', p: '3rem' }}>
                        <Box sx={[{ borderRadius: '50%', m: 0 }, {
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: "0.25rem",
                          position: "relative",
                          fontSize: "1.2rem",
                          transition: "all 0.2s ease-in-out",
                          "&:last-child": { mr: 0, marginRight: 0 },
                          "& .badge": { position: "absolute", right: 0, bottom: 0 },
                          "& svg, & .svg-inline--fa": { display: "block" },
                          marginRight: "0.25rem",
                        }]}>
                          <Box sx={[{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: 0,
                            height: "130px !important",
                            width: "130px !important",
                            lineHeight: "130px !important",
                            p: 0,
                            borderRadius: "50%",
                            m: 0,
                          }, {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: "0.25rem",
                            position: "relative",
                            fontSize: "1.2rem",
                            transition: "all 0.2s ease-in-out",
                            "&:last-child": { mr: 0, marginRight: 0 },
                            "& .badge": { position: "absolute", right: 0, bottom: 0 },
                            "& svg, & .svg-inline--fa": { display: "block" },
                            marginRight: "0.25rem",
                          }, strategyHighlightBlueSx]}>
                            <FontAwesomeIcon icon={['fas', 'house-chimney']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
                          </Box>
                        </Box>
                        <Box
                          component="h4"
                          sx={{ fontWeight: 700, mt: '1.5rem' }}
                        >
                          No Comps Found...
                        </Box>
                        <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                          This property has no comps
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </>
            )}
            {alignment === 'potential' && activeTab === '2' && (
              <Grid
                container
                direction="row"
                spacing={4}
                sx={{
                  justifyContent: 'center',
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                }}
              >
                {unfilteredPotentialComps.length > 0 ? (
                  compact(potentialComps).length > 0 ? (
                    <CompsList
                      comps={map(
                        stableSort(
                          compact(potentialComps),
                          getSorting(order, orderByTarget),
                        ),
                        (comp, index) => ({
                          ...comp,
                          mapIndex: index,
                        }),
                      )}
                      ordering={ordering}
                      property={property}
                      openEdit={openEdit}
                      selected={selected}
                      selectComp={selectComp}
                      selectAll={selectAll}
                      shared={props.shared || props.public}
                      title="Potential Comps"
                    />
                  ) : (
                    <Grid size={12}>
                      <AllPropertiesFiltered />
                    </Grid>
                  )
                ) : (
                  <Grid size={12}>
                    <Box sx={{ textAlign: 'center', p: '3rem' }}>
                      <Box sx={[{ borderRadius: '50%', m: 0 }, {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: "0.25rem",
                        position: "relative",
                        fontSize: "1.2rem",
                        transition: "all 0.2s ease-in-out",
                        "&:last-child": { mr: 0, marginRight: 0 },
                        "& .badge": { position: "absolute", right: 0, bottom: 0 },
                        "& svg, & .svg-inline--fa": { display: "block" },
                        marginRight: "0.25rem",
                      }]}>
                        <Box sx={[{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: 0,
                          height: "130px !important",
                          width: "130px !important",
                          lineHeight: "130px !important",
                          p: 0,
                          borderRadius: "50%",
                          m: 0,
                        }, {
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: "0.25rem",
                          position: "relative",
                          fontSize: "1.2rem",
                          transition: "all 0.2s ease-in-out",
                          "&:last-child": { mr: 0, marginRight: 0 },
                          "& .badge": { position: "absolute", right: 0, bottom: 0 },
                          "& svg, & .svg-inline--fa": { display: "block" },
                          marginRight: "0.25rem",
                        }, strategyHighlightBlueSx]}>
                          <FontAwesomeIcon icon={['fas', 'house-chimney']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
                        </Box>
                      </Box>
                      <Box
                        component="h4"
                        sx={{ fontWeight: 700, mt: '1.5rem' }}
                      >
                        No Comps Found...
                      </Box>
                      <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                        This property has no potential comps
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            )}
            {alignment === 'potential' && activeTab === '1' && (
              <>
                <Grid sx={{ mt: 2, mb: 1, overflow: 'visible' }}>
                  <Typography
                    variant="h5"
                    sx={{ lineHeight: 1.4, overflow: 'visible' }}
                  >
                    Potential Comparable Properties
                  </Typography>
                </Grid>
                <Grid container>
                  {unfilteredPotentialComps.length > 0 ? (
                    compact(potentialComps).length > 0 ? (
                      <>
                        <Grid
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 380px), 1fr))",
                            gap: 4,
                            width: "100%",
                            mt: "10px",
                          }}
                        >
                          {map(
                            slice(
                              stableSort(
                                compact(potentialComps),
                                getSorting(order, orderByTarget),
                              ),
                              (potentialPage - 1) * 24,
                              potentialPage * 24,
                            ),
                            (comp, index) => (
                              <CompsCard
                                key={
                                  comp?._id || `potential-comp-${index}`
                                }
                                organization={organization}
                                comp={comp}
                                index={
                                  (potentialPage - 1) * 24 + index
                                }
                                property={property}
                                openEdit={openEdit}
                                selected={selected}
                                selectComp={selectComp}
                                shared={props.shared || props.public}
                                potential={true}
                              />
                            ),
                          )}
                        </Grid>
                        {Boolean(potentialCount) &&
                          potentialComps.length > 0 && (
                            <Grid size={12}>
                              <Box
                                sx={{
                                  p: '1rem',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <Pagination size="small" count={potentialCount} page={potentialPage} onChange={handlePotentialChange} shared={ props.shared || props.public }
                                  />
                              </Box>
                            </Grid>
                          )}
                      </>
                    ) : (
                      <Grid size={12}>
                        <AllPropertiesFiltered />
                      </Grid>
                    )
                  ) : (
                    <Grid size={12}>
                      <Box sx={{ textAlign: 'center', p: '3rem' }}>
                        <Box sx={[{ borderRadius: '50%', m: 0 }, {
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mr: "0.25rem",
                          position: "relative",
                          fontSize: "1.2rem",
                          transition: "all 0.2s ease-in-out",
                          "&:last-child": { mr: 0, marginRight: 0 },
                          "& .badge": { position: "absolute", right: 0, bottom: 0 },
                          "& svg, & .svg-inline--fa": { display: "block" },
                          marginRight: "0.25rem",
                        }]}>
                          <Box sx={[{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: 0,
                            height: "130px !important",
                            width: "130px !important",
                            lineHeight: "130px !important",
                            p: 0,
                            borderRadius: "50%",
                            m: 0,
                          }, {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mr: "0.25rem",
                            position: "relative",
                            fontSize: "1.2rem",
                            transition: "all 0.2s ease-in-out",
                            "&:last-child": { mr: 0, marginRight: 0 },
                            "& .badge": { position: "absolute", right: 0, bottom: 0 },
                            "& svg, & .svg-inline--fa": { display: "block" },
                            marginRight: "0.25rem",
                          }, strategyHighlightBlueSx]}>
                            <FontAwesomeIcon icon={['fas', 'house-chimney']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
                          </Box>
                        </Box>
                        <Box
                          component="h4"
                          sx={{ fontWeight: 700, mt: '1.5rem' }}
                        >
                          No Comps Found...
                        </Box>
                        <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                          This property has no potential comps
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        )}
      </Grid>
      {showCompsSkeleton ? (
        <Grid size={12}>
          <Grid container spacing={4} sx={strategyMarginTop10Sx}>
            {activeTab === '2' ? (
              <PropertyListSkeleton rowCount={8} />
            ) : (
              <PropertyCardSkeleton count={6} variant="comps" />
            )}
          </Grid>
        </Grid>
      ) : (
        !props.public &&
        !props.shared &&
        isEmpty(props.comps) && (
          <Grid>
            <Box sx={{ textAlign: 'center', p: '3rem' }}>
              <Box sx={[{ borderRadius: '50%', m: 0 }, {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                mr: "0.25rem",
                position: "relative",
                fontSize: "1.2rem",
                transition: "all 0.2s ease-in-out",
                "&:last-child": { mr: 0, marginRight: 0 },
                "& .badge": { position: "absolute", right: 0, bottom: 0 },
                "& svg, & .svg-inline--fa": { display: "block" },
                marginRight: "0.25rem",
              }]}>
                <Box sx={[{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: 0,
                  backgroundColor: "rgb(91.7692307692%, 96.4494720965%, 99.838612368%) !important",
                  "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important" },
                  height: "130px !important",
                  width: "130px !important",
                  lineHeight: "130px !important",
                  p: 0,
                  borderRadius: "50%",
                  m: 0,
                }, {
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: "0.25rem",
                  position: "relative",
                  fontSize: "1.2rem",
                  transition: "all 0.2s ease-in-out",
                  "&:last-child": { mr: 0, marginRight: 0 },
                  "& .badge": { position: "absolute", right: 0, bottom: 0 },
                  "& svg, & .svg-inline--fa": { display: "block" },
                  marginRight: "0.25rem",
                }]}>
                  <CompareIcon
                    sx={strategyAvatarBlueLargeSx}
                  />
                  {/* <FontAwesomeIcon icon={['far', 'folder-open']} style={{ display: 'flex', alignSelf: 'center' }} sx={{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }}/> */}
                </Box>
              </Box>
              <Box
                component="h4"
                sx={{ fontWeight: 700, mt: '1.5rem' }}
              >
                Lets Find Some Comps
              </Box>
              <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                Use Housefolios to help you find comparable properties
                nearby
              </Box>
              <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                Find comps are run in the background when a property
                is first analyzed. Please wait a few minutes to see if
                comps will be found.
              </Box>
              <Box sx={{ pt: '1.5rem' }}>
                <Button
                  data-tour="comps-step-3"
                  variant="contained"
                  size="small"
                  //onClick={handleMenuOpen}
                  onClick={
                    props.session &&
                    props.session.me &&
                    props.session.me.activeOrg &&
                    props.session.me.activeOrg.isRealeflow &&
                    property?.realeflowData
                      ? handleMenuOpen
                      : handleOpenAddCompAddress
                  } sx={{
                    backgroundColor: '#1cc943',
                    color: 'white',
                  }}>
                  <AddTwoToneIcon /**/ style={strategyIconGap10Style} sx={{ width: "50%" }} />
                  Add Comp
                </Button>
              </Box>
            </Box>
          </Grid>
        )
      )}
      {!props.shared && (
        <Menu
          anchorEl={compMenu}
          keepMounted
          open={Boolean(compMenu)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{ list: { sx: { p: 0 } } }}
        >
          <Box sx={{ p: '0.5rem' }}>
            <List component="div" sx={[{
              width: "100%",
              "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
              "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
              "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
            }, { p: 0, m: 0, flexDirection: 'column' }, {
              "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                color: "#4f5062",
                background: "rgba(79, 80, 98, 0.05)",
                "&::before": { background: "#4f5062" },
              },
            }]}>
              <ListItemButton onClick={handleOpenAddCompAddress}>
                <AddTwoToneIcon style={strategyIconGap10Style} />
                Add Comp
              </ListItemButton>
              {props?.session?.me?.activeOrg?.isRealeflow && (
                <ListItemButton onClick={handleFindMenuOpen}>
                  <AddTwoToneIcon style={strategyIconGap10Style} />
                  Find Comps
                </ListItemButton>
              )}
            </List>
          </Box>
        </Menu>
      )}
      <Collapse
        in={selected.length > 0} sx={strategyFixedBottomBarSx}>
        <Alert
          icon={false}
          sx={{
            display: 'block',
            backgroundColor: '#253152',
            color: '#fff',
            border: 'none',
            borderRadius: '0.65rem',
            boxShadow:
              '0 0.313rem 0.8rem rgba(7, 9, 25, 0.3), 0 0.126rem 0.225rem rgba(7, 9, 25, 0.1)',
            overflow: 'hidden',
            '& .MuiAlert-message': {
              width: '100%',
              color: '#fff',
            },
            '& .MuiTypography-root': {
              color: '#fff',
            },
          }}
        >
          {/* <Typography sx={{ color: 'white', fontWeight: 600 }}>You have unsaved changes</Typography> */}
          <Grid
            container
            direction="row"
            wrap="nowrap"
            sx={[
              strategyOverflowScrollSx,
              {
                justifyContent: 'space-between',
                alignItems: 'center',
              },
            ]}
          >
            <Grid>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <Tooltip title="Deselect Comps">
                    <IconButton
                      onClick={() => setSelected([])}
                      size="large"
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'xmark']}
                        sx={strategyWhiteTextSx}
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid>
                  <Typography
                    sx={{
                      whiteSpace: 'nowrap',
                      mr: '20px',
                      color: '#fff',
                      fontWeight: 600,
                    }}
                  >
                    {selected.length} selected
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={strategyDrawerLegendSx}>
              <Grid container wrap="nowrap">
                {selected.length === 1 && (
                  <Grid>
                    <Tooltip title="Edit Comp">
                      <IconButton
                       
                        disabled={loader}
                        onClick={() =>
                          openEdit(
                            find(
                              comps,
                              (comp) => comp._id === head(selected),
                            ),
                          )
                        }
                        size="large" sx={strategyWhiteTextSx}>
                        <EditIcon sx={{ mr: '0.5rem' }} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {potentialSelected && (
                  <Grid>
                    <Tooltip title="Bulk Set as Comp">
                      <IconButton
                        disabled={loader}
                        onClick={() => setBulkSetCompDialog(true)}
                        size="large"
                      >
                        <FontAwesomeIcon
                          icon={['far', 'house-circle-check']}
                          sx={strategyWhiteTextSx}
                        />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {actualSelected && (
                  <Grid>
                    <Tooltip title="Bulk Set as Potential">
                      <IconButton
                        disabled={loader}
                        onClick={() =>
                          setBulkSetPotentialDialog(true)
                        }
                        size="large"
                      >
                        <FontAwesomeIcon
                          icon={['fas', 'house-circle-exclamation']}
                          sx={strategyWhiteTextSx}
                        />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                <Grid>
                  <DeleteComps
                    bulkActionsNotifications={true}
                    selected={selected}
                    setSelected={setSelected}
                    propertyId={property._id}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid disabled />
          </Grid>
        </Alert>
      </Collapse>
      <Dialog
        open={openAddCompAddress}
        onClose={handleCloseAddCompAddress}
        maxWidth="sm"
        fullWidth={true}
        slotProps={{
          paper: { sx: { overflow: 'visible' } },
        }}
      >
        <BlockUi
          blocking={loader}
          loader={
            <PacmanLoader color={'var(--primary)'} loading={true} />
          }
          message={
            <Box sx={{ color: '#368cff' }}>
              <p>Connecting</p>
              <p>
                {(((minutes * 60 + seconds) / 120) * 100).toFixed(1)}%
                Complete
              </p>
            </Box>
          }
        >
          <DialogTitle>Add Comp Property</DialogTitle>
          <DialogContent sx={{ overflow: 'visible' }} data-hf="places-dialog-content">
            <Box data-hf-place-field="" sx={{
              width: "100%",
              position: "relative",
              minHeight: 40,
              marginTop: 0,
              "& > input": { display: "none" },
            }}>
              <input
                id="autocomplete"
                type="text"
                placeholder="Search Property"
                autoFocus
                aria-label="Search Property"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <ApolloConsumer>
              {(client) => (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!placeResult}
                  onClick={() => searchForComp(client)}
                >
                  Search
                </Button>
              )}
            </ApolloConsumer>
          </DialogActions>
        </BlockUi>
        {/* <Card>
          <CardHeader title="Add Comp Property" />
          <CardContent>
            <TextField
              id="autocomplete"
              label="Search Property"
              placeholder="Address"
              fullWidth={true}
            />
          </CardContent>
          <Divider />
          <CardActions>
            <Typography sx={strategyFlexGrowSx} />
            <ApolloConsumer>
              {client => (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!placeResult}
                  onClick={() => searchForComp(client)}>
                  Search
                </Button>
              )}
            </ApolloConsumer>
          </CardActions>
        </Card> */}
      </Dialog>

      <Dialog
        scroll="body"
        maxWidth="md"
        open={openVerifyComp}
        onClose={handleCloseVerifyComp}
        fullWidth={true}
      >
        <BlockUi
          blocking={loader}
          loader={
            <PacmanLoader color={'var(--primary)'} loading={true} />
          }
          message={
            <Box sx={{ color: '#368cff' }}>Analyzing Comp</Box>
          }
        >
          <Grid container spacing={0}>
            <Grid size={{ xs: 12, sm: 5 }}>
              <Box sx={strategyFullSizeSx}>
                <Map
                  properties={[compPropertyInput]}
                  height="100%"
                  streetView={false}
                  hide={openAddCompAddress}
                  noInfoWindow
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 7 }}>
              <Card>
                <CardHeader
                  title="Confirm comp details"
                  action={
                    <IconButton
                      onClick={handleCloseVerifyComp}
                      disabled={loader}
                      size="large"
                    >
                      <CloseOutlined />
                    </IconButton>
                  }
                />
                <Divider />
                <CardContent>
                  <Alert severity="info" sx={{ mb: '1rem' }}>
                    Enter beds and sqft (and any missing address
                    fields) to add this comp.
                  </Alert>
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    sx={{ mb: 0, alignItems: 'center' }}
                    >
                    <Grid size={12}>
                      <Typography
                        color="primary" sx={strategySemiboldPullUpSx}>
                        Location
                      </Typography>
                    </Grid>
                    {map(compAddressFields, (field) => (
                      <Fragment key={field.name || field.label}>
                        {renderInput(field)}
                      </Fragment>
                    ))}
                  </Grid>
                  <Divider
                    sx={strategyMargin20VerticalSx}
                  />
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    sx={{ mb: 0, alignItems: 'center' }}
                    >
                    <Grid size={12}>
                      <Typography
                        color="primary" sx={strategySemiboldPullUpSx}>
                        Comp Details
                      </Typography>
                    </Grid>
                    {map(compDetailFields, (field) => (
                      <Fragment key={field.name || field.label}>
                        {renderInput(field)}
                      </Fragment>
                    ))}
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sx={[
                      strategyMarginTop12Sx,
                      {
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      },
                    ]}
                  >
                    <Typography
                      sx={strategyErrorTextSx}
                    >
                      Required: Zip, Beds, Sqft
                    </Typography>
                    <Button
                      variant="text"
                      color="primary"
                      size="small"
                      disabled={
                        !compPropertyInput.address &&
                        !compPropertyInput.zip
                      }
                      onClick={() => {
                        const query = compact([
                          compPropertyInput.address,
                          compPropertyInput.city,
                          compPropertyInput.state,
                          compPropertyInput.zip,
                          'beds sqft year built',
                        ]).join(' ')
                        if (!query.trim()) return
                        window.open(
                          `https://www.google.com/search?q=${encodeURIComponent(query)}`,
                          '_blank',
                          'noopener,noreferrer',
                        )
                      }}
                      startIcon={
                        <FontAwesomeIcon icon={['fab', 'google']} />
                      }
                      sx={{ textTransform: 'none' }}
                    >
                      Google this property
                    </Button>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Grid size={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={strategyBoxShadowNoneSx}
                      disabled={
                        loader ||
                        !compPropertyInput.zip ||
                        !Number(compPropertyInput.beds) ||
                        !Number(compPropertyInput.sqft)
                      }
                      fullWidth={true}
                      onClick={submitComp()}
                    >
                      <Typography>Add Comp</Typography>
                    </Button>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </BlockUi>
      </Dialog>

      <Dialog
        // classes={{ paper: 'modal-content bg-white rounded-lg modal-dark' }}
        open={openFixComp}
        onClose={handleCloseFixComp}
      >
        <DialogTitle>Correct the address</DialogTitle>
        <DialogContent sx={strategyPadVert15Sx}>
          <BlockUi
            blocking={loader}
            loader={
              <PacmanLoader color={'var(--primary)'} loading={true} />
            }
            message={
              <Box sx={{ color: '#368cff' }}>Updating Comp</Box>
            }
          >
            <DialogContent>
              <Grid
                container
                direction="row"
                spacing={1}
                sx={{ mb: 0, alignItems: 'center' }}
                >
                <Grid size={12}>
                  <Typography
                    color="primary" sx={strategySemiboldPullUpSx}>
                    Location
                  </Typography>
                </Grid>
                {map(compAddressFields, (field) => (
                  <Fragment key={field.name || field.label}>
                    {renderInput(field)}
                  </Fragment>
                ))}
              </Grid>
              <Divider sx={strategyMargin20VerticalSx} />
              <Grid
                container
                direction="row"
                spacing={1}
                sx={{ mb: 0, alignItems: 'center' }}
                >
                <Grid size={12}>
                  <List sx={[{ display: 'flex', mt: '1rem' }, {
                    paddingTop: 0,
                    paddingBottom: 0,
                    "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root, & > .MuiListItem-root": {
                      color: "#a6a6b9",
                      position: "relative",
                      transition: "all 0.2s ease-in-out",
                      padding: "0.75rem 1.25rem 1rem",
                      background: "transparent",
                      width: "auto",
                      minHeight: 48,
                      margin: 0,
                      borderRadius: 0,
                      alignItems: "center",
                      alignSelf: "stretch",
                      boxSizing: "border-box",
                      "& .divider": {
                        width: "100%",
                        borderRadius: "0.75rem",
                        height: 3,
                        background: "#368cff",
                        visibility: "hidden",
                        opacity: 0,
                        transform: "translateY(-10px)",
                        transition: "all 0.2s ease-in-out",
                        position: "absolute",
                        left: 0,
                        bottom: 0,
                      },
                      "&:hover": { color: "#000", background: "transparent" },
                      "&.Mui-selected": {
                        color: "#368cff",
                        background: "transparent",
                        "&:hover": { color: "#368cff" },
                        "& .divider": { visibility: "inherit", opacity: 1, transform: "translateY(0)" },
                        fontWeight: 700,
                      },
                    },
                    position: "relative",
                    zIndex: 4,
                    padding: 0,
                    "&::after": {
                      background: "#f4f5fd",
                      height: 3,
                      borderRadius: "0.75rem",
                      display: "block",
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      content: "\"\"",
                      zIndex: 5,
                    },
                    "& .MuiListItem-root.MuiListItem-button + .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root + .MuiListItemButton-root": { marginLeft: "2rem" },
                    "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": {
                      padding: "0.75rem 0 1rem",
                      margin: 0,
                      "& .divider": { zIndex: 8, left: 0, width: "100%" },
                    },
                  }]}>
                    <Typography
                      color="primary" sx={strategySemiboldPullUpSx}>
                      Comp Details
                    </Typography>
                  </List>
                </Grid>
                {map(compDetailFields, (field) => (
                  <Fragment key={field.name || field.label}>
                    {renderInput(field)}
                  </Fragment>
                ))}
              </Grid>
            </DialogContent>
          </BlockUi>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseFixComp}
            variant="text"
            disabled={loader}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loader}
            onClick={submitComp()}
          >
            Add Comp
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddComp}
        onClose={handleCloseAddComp}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          {edit ? 'Edit Comp' : 'Add Comp'}{' '}
          {edit && (
            <Avatar sx={{
                height: 30,
                width: 30,
                position: 'absolute',
                top: 15,
                right: 20,
                backgroundColor: compMarkerColor(
                  compPropertyInput.potential,
                ),
                color: '#fff',
              }}>
              {compPropertyInput.indexTest}
            </Avatar>
          )}
        </DialogTitle>
        {/* <Grid> */}

        {/* </Grid> */}
        <DialogContent sx={{ p: '1.5rem' }}>
          <BlockUi
            blocking={loader}
            loader={
              <PacmanLoader color={'var(--primary)'} loading={true} />
            }
            message={<Box sx={{ color: '#368cff' }}>Saving Comp</Box>}
          >
            <Grid container direction="row">
              <Grid size={{ sm: 12 }} sx={strategyPad10Sx}>
                <Grid container direction="column">
                  <Slider1 {...widgetsCarousels1B} sx={{ flexShrink: 0, width: "100%" }}>
                    {!isEmpty(selectedImages) &&
                      map(selectedImages, (image) => (
                        <div
                          onClick={(event) => {
                            event.stopPropagation()
                          }}
                        >
                          <Card sx={[strategyCompCardSx, { boxShadow: 'none' }]}>
                            <Grid
                              container
                              direction="column" sx={[strategyFullHeight100Sx, {
                                justifyContent: 'center',
                              }]}>
                              <Grid>
                                <Box sx={[strategyTransparentCenterSx, {
                                  position: "relative",
                                  borderTopLeftRadius: "inherit",
                                  borderTopRightRadius: "inherit",
                                  "& .img-wrapper-overlay": {
                                    width: "100%",
                                    height: "100%",
                                    transition: "all 0.2s ease-in-out",
                                    opacity: 0,
                                    visibility: "hidden",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                                    display: "flex",
                                    alignItems: "center",
                                    alignContent: "center",
                                    color: "#fff",
                                    borderTopLeftRadius: "inherit",
                                    borderTopRightRadius: "inherit",
                                    "@media (max-width: 575.98px)": {
                                      "& + img": { width: "100% !important" },
                                    },
                                    "& .overlay-btn-wrapper": {
                                      position: "relative",
                                      zIndex: 3,
                                      textAlign: "center",
                                      width: "100%",
                                    },
                                    "&::before": {
                                      zIndex: 2,
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      content: "\"\"",
                                      width: "100%",
                                      height: "100%",
                                      transition: "all 0.2s ease-in-out",
                                      background: "#000",
                                      opacity: 0.75,
                                    },
                                  },
                                  "& .img-wrapper-overlay--visible": {
                                    visibility: "visible",
                                    opacity: 1,
                                    position: "relative",
                                    zIndex: 5,
                                  },
                                  "& .card-badges": { zIndex: 5 },
                                  "a&": {
                                    display: "block",
                                    overflow: "hidden",
                                    "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                                  },
                                }]}>
                                  <Box component="img" src={image} alt="..." sx={[strategyCompImgSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                                </Box>
                                <Avatar
                                  onClick={() =>
                                    handleOpenEditImage(image)
                                  } sx={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    // backgroundColor: 'primary',
                                  }}>
                                  <EditIcon sx={strategyWhiteTextSx}/>
                                </Avatar>
                              </Grid>
                            </Grid>
                          </Card>
                        </div>
                      ))}
                    {!isEmpty(images) &&
                      map(images, (image) => (
                        <div
                          onClick={(event) => {
                            event.stopPropagation()
                          }}
                        >
                          <Card sx={[strategyCompCardSx, { boxShadow: 'none' }]}>
                            <Grid
                              container
                              direction="column" sx={[strategyFullHeight100Sx, {
                                justifyContent: 'center',
                              }]}>
                              <Grid>
                                <Box sx={[strategyTransparentRelCenterSx, {
                                  position: "relative",
                                  borderTopLeftRadius: "inherit",
                                  borderTopRightRadius: "inherit",
                                  "& .img-wrapper-overlay": {
                                    width: "100%",
                                    height: "100%",
                                    transition: "all 0.2s ease-in-out",
                                    opacity: 0,
                                    visibility: "hidden",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    boxShadow: "inset 0 0 2.3rem 0.5rem #000",
                                    display: "flex",
                                    alignItems: "center",
                                    alignContent: "center",
                                    color: "#fff",
                                    borderTopLeftRadius: "inherit",
                                    borderTopRightRadius: "inherit",
                                    "@media (max-width: 575.98px)": {
                                      "& + img": { width: "100% !important" },
                                    },
                                    "& .overlay-btn-wrapper": {
                                      position: "relative",
                                      zIndex: 3,
                                      textAlign: "center",
                                      width: "100%",
                                    },
                                    "&::before": {
                                      zIndex: 2,
                                      position: "absolute",
                                      left: 0,
                                      top: 0,
                                      content: "\"\"",
                                      width: "100%",
                                      height: "100%",
                                      transition: "all 0.2s ease-in-out",
                                      background: "#000",
                                      opacity: 0.75,
                                    },
                                  },
                                  "& .img-wrapper-overlay--visible": {
                                    visibility: "visible",
                                    opacity: 1,
                                    position: "relative",
                                    zIndex: 5,
                                  },
                                  "& .card-badges": { zIndex: 5 },
                                  "a&": {
                                    display: "block",
                                    overflow: "hidden",
                                    "&:hover .img-wrapper-overlay": { opacity: 1, visibility: "visible" },
                                  },
                                }]}>
                                  <Box sx={[{ backgroundImage: 'url(' + image.url_small + ')', height: 325, display: 'flex', justifyContent: 'center', alignItems: 'center', }, { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }]}>
                                    <Box component="img" src={image.url} alt="..." loading="lazy" sx={[strategyCompImgSx, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                                  </Box>
                                </Box>
                                <Avatar
                                  onClick={(event) =>
                                    handleEditImageMoreVertOpen(
                                      event,
                                      image,
                                    )
                                  } sx={strategyAbsTopRightPinkSx}>
                                  <MoreVertIcon sx={strategyWhiteTextSx}/>
                                </Avatar>
                                {/* <Avatar
                              onClick={toggleOpenDeleteImage(image._id)} sx={strategyAbsTopRightPinkSx}>
                              <DeleteTwoTone sx={strategyWhiteTextSx}/>
                            </Avatar> */}
                              </Grid>
                            </Grid>
                          </Card>
                        </div>
                      ))}
                  </Slider1>
                  <Menu
                    anchorEl={editImageMoreVert}
                    keepMounted
                    open={Boolean(editImageMoreVert)}
                    onClose={handleEditImageMoreVertClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    slotProps={{ list: { sx: { p: 0 } } }}
                  >
                    <Box sx={{ p: '0.5rem' }}>
                      <List component="div" sx={[{
                        width: "100%",
                        "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                        "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
                        "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                      }, { p: 0, m: 0, flexDirection: 'column' }, {
                        "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                          color: "#4f5062",
                          background: "rgba(79, 80, 98, 0.05)",
                          "&::before": { background: "#4f5062" },
                        },
                      }]}>
                        <ListItemButton
                          onClick={() =>
                            handleOpenEditImage(selectedEditImage)
                          }
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          <EditIcon sx={strategyMarginRight10Sx} />
                          Edit Image
                        </ListItemButton>
                        <ListItemButton
                          onClick={toggleOpenDeleteImage(
                            selectedEditImage._id,
                          )}
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          <DeleteTwoTone sx={strategyMarginRight10Sx} />
                          Delete Image
                        </ListItemButton>
                        <ListItemButton
                          onClick={toggleOpenManageImages}
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          <ImageOutlinedIcon
                            style={strategyIconGap10Style}
                          />
                          Manage Images
                        </ListItemButton>
                      </List>
                    </Box>
                  </Menu>
                </Grid>
              </Grid>
              <Grid size={12} sx={strategyMarginBottom25Sx}>
                <div>
                  <Box
                    {...getRootProps()} sx={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      outline: "none !important",
                      "& *": { outline: "none !important" },
                    }}
                  >
                    <input {...getInputProps()} />
                    <Box sx={{
                      padding: "1rem 1rem",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                      textAlign: "center",
                      color: "#a6a6b9",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      border: "2px dashed #e6e7f1",
                      borderRadius: "0.65rem",
                      backgroundColor: "#f8f9ff",
                      "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important", borderColor: "rgba(255, 255, 255, 0.28) !important", color: "rgba(255, 255, 255, 0.7) !important" },
                      "html[data-color-mode=\"dark\"] &:hover": { borderColor: "#368cff !important", color: "rgba(255, 255, 255, 0.87) !important", backgroundColor: "#333 !important" },
                    }}>
                      {/* {isDragAccept && (
                        <div>
                          <Box sx={[{ marginBottom: '1rem', backgroundColor: '#1bc943', borderRadius: '50%', color: '#fff' }, {
                            height: "100px !important",
                            width: "100px !important",
                            lineHeight: "100px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            transition: "all 0.2s ease-in-out !important",
                            transform: "scale(1) !important",
                            "&:hover": { transform: "scale(1.12)" },
                            boxShadow: "0 0.46875rem 2.1875rem rgba(27, 201, 67, 0.03), 0 0.9375rem 1.40625rem rgba(27, 201, 67, 0.03), 0 0.25rem 0.53125rem rgba(27, 201, 67, 0.05), 0 0.125rem 0.1875rem rgba(27, 201, 67, 0.03) !important",
                          }]}>
                            <CheckIcon  sx={{
                              height: "50px !important",
                              width: "50px !important",
                              lineHeight: "50px !important",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }}/>
                          </Box>
                          <Box sx={[{ color: '#1bc943' }, { fontSize: "0.875rem !important" }]}>
                            All files will be uploaded!
                              </Box>
                        </div>
                      )}
                      {isDragReject && (
                        <div>
                          <Box sx={[{ marginBottom: '1rem', backgroundColor: '#f83245', borderRadius: '50%', color: '#fff' }, {
                            height: "100px !important",
                            width: "100px !important",
                            lineHeight: "100px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            transition: "all 0.2s ease-in-out !important",
                            transform: "scale(1) !important",
                            "&:hover": { transform: "scale(1.12)" },
                            boxShadow: "0 0.46875rem 2.1875rem rgba(248, 50, 69, 0.03), 0 0.9375rem 1.40625rem rgba(248, 50, 69, 0.03), 0 0.25rem 0.53125rem rgba(248, 50, 69, 0.05), 0 0.125rem 0.1875rem rgba(248, 50, 69, 0.03) !important",
                          }]}>
                            <CloseTwoToneIcon  sx={{
                              height: "50px !important",
                              width: "50px !important",
                              lineHeight: "50px !important",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }}/>
                          </Box>
                          <Box sx={[{ color: '#f83245' }, { fontSize: "0.875rem !important" }]}>
                            Some files will be rejected!
                              </Box>
                        </div>
                      )}
                      {!isDragActive && (
                        <div>
                          <Box sx={[{ marginBottom: '1rem', backgroundColor: '#fff', borderRadius: '50%', color: '#368cff' }, {
                            height: "100px !important",
                            width: "100px !important",
                            lineHeight: "100px !important",
                            display: "inline-flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            border: 0,
                            transition: "all 0.2s ease-in-out !important",
                            transform: "scale(1) !important",
                            "&:hover": { transform: "scale(1.12)" },
                            boxShadow: "0 0.46875rem 2.1875rem rgba(244, 245, 253, 0.03), 0 0.9375rem 1.40625rem rgba(244, 245, 253, 0.03), 0 0.25rem 0.53125rem rgba(244, 245, 253, 0.05), 0 0.125rem 0.1875rem rgba(244, 245, 253, 0.03) !important",
                          }]}>
                            <CloudUploadTwoToneIcon  sx={{
                              height: "50px !important",
                              width: "50px !important",
                              lineHeight: "50px !important",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              p: 0,
                            }}/>
                          </Box>
                          <Box sx={{ fontSize: "0.875rem !important" }}>
                            Drag and drop files here <Box component="span" sx={[{ color: '#4f5062' }, { fontSize: "0.8333333333rem !important" }]}>(jpg/png images)</Box>
                          </Box>
                        </div>
                      )}
                      <Box component="small" sx={{ paddingTop: '0.5rem', paddingBottom: '0.5rem', color: 'rgba(59, 62, 102, 0.5)' }}>
                        or
                          </Box>
                      <div>
                        <Button sx={[{ fontWeight: 700, paddingLeft: '1.5rem', paddingRight: '1.5rem' }, {
                          boxShadow: "0 0.25rem 0.55rem rgba(54, 140, 255, 0.35)",
                          color: "#fff",
                          backgroundColor: "#368cff",
                          backgroundImage: "none",
                          borderColor: "#368cff",
                          "&:not(:disabled):hover": { backgroundColor: "#368cff", color: "#fff" },
                          "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#036fff" },
                          "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(54, 140, 255, 0.4), 0 0.0625rem 0.385rem rgba(54, 140, 255, 0.54)" },
                          "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                          "html[data-color-mode=\"dark\"] &": { color: "#fff !important" },
                          transition: "all 0.2s ease-in-out !important",
                          transform: "scale(1) !important",
                          position: "relative",
                          zIndex: "0",
                          "&:hover": { transform: "scale(1.08)", zIndex: 3 },
                          borderRadius: "4.5rem",
                        }]}>
                          <Box component="span" sx={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                            Browse Files
                              </Box>
                        </Button>
                      </div> */}
                      <Box sx={strategyCenterTextSx}>
                        <Button
                          variant="contained"
                          margin="dense" sx={{
                            backgroundColor: '#368CFF',
                            color: 'white',
                          }}>
                          Upload Additional Images
                        </Button>
                      </Box>
                      {/* <Box sx={strategyAbsTopRight10Sx}>
                      <IconButton>
                        <FontAwesomeIcon
                          icon={[ 'far', 'images')} />
                      </IconButton>
                    </Box> */}
                    </Box>
                  </Box>
                </div>
              </Grid>
              <Grid size={{ sm: 12 }}>
                <Grid container direction="row" spacing={1}>
                  <Grid size={12}>
                    <Typography color="primary" variant="h6">
                      Property Details
                    </Typography>
                  </Grid>
                  {map(compFields, (field) => (
                    <Fragment key={field.name || field.label}>
                      {renderInput(field)}
                    </Fragment>
                  ))}
                  <Grid size={12} sx={strategyMarginTop10OnlySx}>
                    <Typography color="primary" variant="h6">
                      Financial Details
                    </Typography>
                  </Grid>
                  {map(compFinancialFields, (field) => (
                    <Fragment key={field.name || field.label}>
                      {renderInput(field)}
                    </Fragment>
                  ))}
                  <Grid size={12} sx={strategyMarginTop5Sx}>
                    <Grid container>
                      <Grid size={12} sx={strategyMarginBottomNeg30Sx}>
                        Adjust Comp
                      </Grid>
                      <Grid size={12}>
                        <Slider
                          color="#008bff"
                          value={compPropertyInput.priceAdjustment}
                          onChange={(event, value) => {
                          onChangeSlider(
                          event,
                          value,
                          'priceAdjustment',
                          )
                          }}
                          onChangeCommitted={(event, value) => {
                          onChangeSlider(
                          event,
                          value,
                          'priceAdjustment',
                          )
                          }}
                          marks={true}
                          track={false}
                          valueLabelDisplay="auto"
                          min={-15}
                          max={15}
                          step={2.5}
                          valueLabelFormat={(x) => `${x}%`} sx={[{
                          width: '95%',
                          marginLeft: '18px',
                          }, { my: '1rem' }]}/>
                      </Grid>
                      {/* <Grid size={12} sx={{ marginTop: '-30px' }}>
                      <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid>Worse</Grid>
                        <Grid>Same</Grid>
                        <Grid>Better</Grid>
                      </Grid>
                    </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </BlockUi>
        </DialogContent>
        <DialogActions>
          {edit && (
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleClickActionsMenu}
            >
              Actions
              <KeyboardArrowDownTwoTone />
            </Button>
          )}
          <Typography sx={strategyFlexGrowSx} />
          <Button
            size="small"
            variant="text"
            onClick={handleCloseAddComp}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={submitComp()}
          >
            Save
          </Button>
        </DialogActions>
        <Menu
          anchorEl={anchorElActionsMenu}
          keepMounted
          open={Boolean(anchorElActionsMenu)}
          onClose={handleCloseActionsMenu}
          slotProps={{ list: { sx: { p: 0 } } }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box sx={{ minWidth: "10rem" }}>
            <List
              component="div"
              disablePadding
              sx={{
                "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#368cff",
                  background: "rgba(54, 140, 255, 0.05)",
                  "&::before": { background: "#368cff" },
                },
              }}
            >
              <ListItemButton
                key="changePotential"
                onClick={submitComp(true)}
                sx={{ width: '100%' }}
              >
                <Box
                  sx={[
                    strategyPad5Sx,
                    {
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      width: '100%',
                    },
                  ]}
                >
                  <Box
                    sx={{
                      width: 28,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {potential ? (
                      <FontAwesomeIcon
                        icon={['far', 'house-circle-check']}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={['fas', 'house-circle-exclamation']}
                      />
                    )}
                  </Box>
                  <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                    Set as {potential ? 'Comp' : 'Potential'}
                  </Box>
                </Box>
              </ListItemButton>
              <ListItemButton
                key="zillow"
                onClick={() =>
                  window.open(
                    `https://www.zillow.com/homes/${kebabCase(
                      compPropertyInput.address,
                    )},-${compPropertyInput.state},-${
                      compPropertyInput.zip
                    }_rb/`,
                    '_blank' /*'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400'*/,
                  )
                }
                sx={{ width: '100%' }}
              >
                <Box
                  sx={[
                    strategyPad5Sx,
                    {
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      width: '100%',
                    },
                  ]}
                >
                  <Box
                    sx={{
                      width: 28,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FontAwesomeIcon
                      icon={['fas', 'arrow-up-right-from-square']}
                      sx={{ fontSize: "1.15rem !important" }}
                    />
                  </Box>
                  <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                    Open Zillow
                  </Box>
                </Box>
              </ListItemButton>
              <ListItemButton
                key="delete"
                onClick={toggleDeleteComp}
                sx={{ width: '100%' }}
              >
                <Box
                  sx={[
                    strategyPad5Sx,
                    {
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      width: '100%',
                    },
                  ]}
                >
                  <Box
                    sx={{
                      width: 28,
                      flexShrink: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FontAwesomeIcon icon={['far', 'trash-can']} />
                  </Box>
                  <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                    Delete
                  </Box>
                </Box>
              </ListItemButton>
            </List>
          </Box>
        </Menu>
      </Dialog>
      <Dialog
        open={openDeleteComp}
        onClose={toggleDeleteComp}
      >
        <Box sx={{ textAlign: 'center', p: '3rem' }}>
          <Box sx={[{ borderRadius: '50%', m: 0 }, {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            mr: "0.25rem",
            position: "relative",
            fontSize: "1.2rem",
            transition: "all 0.2s ease-in-out",
            "&:last-child": { mr: 0, marginRight: 0 },
            "& .badge": { position: "absolute", right: 0, bottom: 0 },
            "& svg, & .svg-inline--fa": { display: "block" },
            marginRight: "0.25rem",
          }]}>
            <Box sx={[{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: 0,
              backgroundColor: "rgb(100%, 95.9215686275%, 96.418938307%) !important",
              height: "130px !important",
              width: "130px !important",
              lineHeight: "130px !important",
              p: 0,
              borderRadius: "50%",
              color: "#f83245",
              m: 0,
            }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <FontAwesomeIcon icon={['fas', 'xmark']} sx={[{ fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }, strategyFlexSelfCenterSx]} />
            </Box>
          </Box>
          <Box component="h4" sx={{ fontWeight: 700, mt: '1.5rem' }}>
            Are you sure you want to delete this?
          </Box>
          <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
            All data will be deleted. This action cannot be undone.
          </Box>
          <Box sx={{ pt: '1.5rem' }}>
            <Button variant="text" onClick={toggleDeleteComp} sx={{
              backgroundColor: "rgba(248, 249, 255, 0.15)",
              color: "#3b3e66",
              borderColor: "transparent",
              "&:hover, &.active": { backgroundColor: "#f8f9ff", color: "#3b3e66" },
              "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#3b3e66" },
              borderRadius: "4.5rem",
            }}>
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Cancel</Box>
            </Button>
            <Button variant="contained" onClick={onDelete} sx={[{ backgroundColor: '#f83145', color: 'white', marginLeft: '0.25rem', marginRight: '0.25rem' }, {
              boxShadow: "0 0.25rem 0.55rem rgba(248, 50, 69, 0.35)",
              color: "#fff",
              backgroundColor: "#f83245",
              backgroundImage: "none",
              borderColor: "#f83245",
              "&:not(:disabled):hover": { backgroundColor: "#f83245", color: "#fff" },
              "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#ef081e" },
              "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(248, 50, 69, 0.4), 0 0.0625rem 0.385rem rgba(248, 50, 69, 0.54)" },
              "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
              borderRadius: "4.5rem",
            }]}>
              <Box component="span" sx={{
                display: "inline-block",
                "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
              }}>Delete</Box>
            </Button>
          </Box>
        </Box>
      </Dialog>
      <ImageCropper
        open={openEditImage}
        imageSrc={selectedEditImage.url || selectedEditImage}
        saveImage={saveCroppedImage}
        replaceOption={true}
        handleClose={handleCloseEditImage}
      />
      <Dialog
        open={openDeleteImage}
        onClose={toggleOpenDeleteImage()}
      >
        <DialogTitle sx={strategyPadBottom0Sx}>
          Delete Image
        </DialogTitle>

        <form
          onSubmit={(event) => onSubmitDelete(event)}
        >
          <DialogContent>
            Are you sure you want to delete this image? This action
            can't be undone.
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleOpenDeleteImage()}>CANCEL</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loader}
            >
              DELETE
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog open={bulkSetCompDialog} onClose={() => closeBulk()}>
        <DialogTitle>Mark Actual</DialogTitle>
        <DialogContent>
          Would you like to set the selected potential comps as actual
          comps?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBulkSetCompDialog(false)
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleBulkDialog(false)
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={bulkSetPotentialDialog}
        onClose={() => closeBulk()}
      >
        <DialogTitle>Mark Potential</DialogTitle>
        <DialogContent>
          Would you like to set the selected comps as potential comps?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBulkSetPotentialDialog(false)
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleBulkDialog(true)
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSelectedDrawing}
        onClose={() => setOpenSelectedDrawing(false)}
      >
        <DialogTitle>Out of Bounds</DialogTitle>
        <DialogContent>
          What would you like to do with the comps outside the shape?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenSelectedDrawing(false)
              setPath([])
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleExcludedComps(true)
            }}
          >
            Mark Potential
          </Button>
          <Button
           
            variant="contained"
            onClick={() => {
              handleExcludedComps(false)
            }} sx={strategyDangerChipSx}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openManageImages}
        onClose={toggleOpenManageImages}
        fullWidth
        maxWidth="md" sx={{ minHeight: minHeight }}>
        <DialogTitle>Manage Comp Images</DialogTitle>
        <DialogContent ref={ref}>
          <DialogContentText>
            Drag the Comp's images to reorder them
          </DialogContentText>
          <SortableList
            items={map(items, (item) => String(item.id))}
            onSortEnd={onSortEnd}
            strategy="xy"
            disabled={props.shared}
          >
            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: 'justify-between',
              }}
            >
              {map(items, (photo, index) => (
                <Grid size={{ xs: 12, md: 6 }} key={photo.id}>
                  <SortableItem id={String(photo.id)}>
                    <Avatar sx={{
                        height: 30,
                        width: 30,
                        backgroundColor: '#368CFF',
                        color: '#fff',
                        position: 'absolute',
                        right: 70,
                        top: 20,
                      }}>
                      {index + 1}
                    </Avatar>
                    <Box sx={[{ backgroundImage: 'url(' + photo.url_small + ')', height: 225, display: 'flex', justifyContent: 'center', alignItems: 'center', aspectRatio: '4/3', }, { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }]}>
                      <Box component="img" src={photo.src} alt="..." loading="lazy" sx={[{ maxHeight: 225, maxWidth: 300, height: 'auto', width: 'auto', aspectRatio: '4/3', borderBottomRightRadius: '0px', objectFit: 'contain', }, { borderRadius: '0.65rem' }, { flexShrink: 0, width: "100%" }]}/>
                    </Box>
                  </SortableItem>
                </Grid>
              ))}
            </Grid>
          </SortableList>
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleOpenManageImages}>Close</Button>
        </DialogActions>
      </Dialog>

      {menu && (
        <Menu
          anchorEl={anchorElDefinition}
          open={Boolean(anchorElDefinition)}
          onClose={() => handleDefinition('', null, null, null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          slotProps={{
            list: { sx: { p: 0 }, dense: true },
          }} sx={strategyWidth400Sx}>
          <Box sx={{ minWidth: "22rem" }}>
            <MenuItem key="menuTitle">
              <Typography variant="h6">{startCase(menu)}</Typography>
            </MenuItem>
            <MenuItem key="menuDescription">
              <Typography
                variant="subtitle2"
                color="textSecondary" sx={strategyWhiteSpaceNormalSx}>
                We found multiple values for this field. Please choose
                the correct option.
              </Typography>
            </MenuItem>
            {map(propertyData[menu], (value) => (
              <MenuItem
                key={menu + ': ' + value}
                onClick={() => {
                  if (menu === 'soldDate') onChangeDateMenu(value)
                  else
                    handleCompChange({
                      target: { name: menuName, value },
                    })
                  handleDefinition('', null, null)
                }}
              >
                <Typography sx={strategyFlexGrowSx} />
                <ListItemText>
                  {menuFormat ? menuFormat.format(value) : value}
                </ListItemText>
              </MenuItem>
            ))}
          </Box>
        </Menu>
      )}

      <Dialog
        fullScreen
        open={findCompMenu}
        onClose={handleFindMenuClose} sx={{ maxHeight: window.innerHeight }}>
        <BlockUi
          blocking={loader}
          loader={
            <PacmanLoader color={'var(--primary)'} loading={true} />
          }
          message={
            <Box sx={{ color: '#368cff' }}>
              <p>Connecting</p>
              <p>
                {(((minutes * 60 + seconds) / 120) * 100).toFixed(1)}%
                Complete
              </p>
            </Box>
          }
        >
          <DialogActions>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleFindMenuClose}
              aria-label="close"
            >
              {/* <CloseIcon /> */}
            </IconButton>
          </DialogActions>

          <DialogContent sx={{
              overflow: 'scroll',
            }}>
            <Grid container spacing={2}>
              {/* Filters Section */}
              <Grid size={12}>
                <Grid
                  container
                  spacing={1}
                  sx={{
                    justifyContent: 'center',
                  }}
                >
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      sx={strategyFullWidthSx}
                    >
                      <TextField
                        value={`${
                          realeflowCompFilters?.beds?.min || 0
                        }-${realeflowCompFilters?.beds?.max || ''}`}
                        label={'Beds'}
                        onClick={toggleRealeflowCompFilters('beds')}
                      />
                    </FormControl>
                    <Menu
                      anchorEl={realeflowCompMenus['beds']}
                      keepMounted
                      open={Boolean(realeflowCompMenus['beds'])}
                      onClose={toggleRealeflowCompFilters('beds')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      slotProps={{ list: { sx: { p: 0 } } }}
                    >
                      <Box sx={{ p: '0.5rem' }}>
                        <Grid
                          container
                          direction={'row'}
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'beds.min'}
                              value={realeflowCompFilters?.beds?.min}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'beds.min',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Beds Min'}
                            />
                          </Grid>
                          <Grid size={1}>
                            <Typography>-</Typography>
                          </Grid>
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'beds.max'}
                              value={realeflowCompFilters?.beds?.max}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'beds.max',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Beds Max'}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Menu>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <TextField
                        value={`${
                          realeflowCompFilters?.baths?.min || 0
                        }-${realeflowCompFilters?.baths?.max || ''}`}
                        label={'Baths'}
                        onClick={toggleRealeflowCompFilters('baths')}
                      />
                    </FormControl>
                    <Menu
                      anchorEl={realeflowCompMenus['baths']}
                      keepMounted
                      open={Boolean(realeflowCompMenus['baths'])}
                      onClose={toggleRealeflowCompFilters('baths')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      slotProps={{ list: { sx: { p: 0 } } }}
                    >
                      <Box sx={{ p: '0.5rem' }}>
                        <Grid
                          container
                          direction={'row'}
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={2}
                              name={'baths.min'}
                              value={realeflowCompFilters?.baths?.min}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'baths.min',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Baths Min'}
                            />
                          </Grid>
                          <Grid size={1}>
                            <Typography>-</Typography>
                          </Grid>
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={2}
                              name={'baths.max'}
                              value={realeflowCompFilters?.baths?.max}
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'baths.max',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Baths Max'}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Menu>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <InputLabel id="demo-simple-select-label">
                        Distance
                      </InputLabel>
                      <Select
                        label="Distance"
                        value={realeflowCompFilters.distance}
                        onChange={onChangeRealeflowFilter}
                        name="distance"
                        sx={{ marginBottom: 2 }}
                      >
                        <MenuItem key="distance-0.5" value={0.5}>
                          0.5
                        </MenuItem>
                        <MenuItem key="distance-1" value={1}>
                          1
                        </MenuItem>
                        <MenuItem key="distance-1.5" value={1.5}>
                          1.5
                        </MenuItem>
                        <MenuItem key="distance-2" value={2}>
                          2
                        </MenuItem>
                        <MenuItem key="distance-2.5" value={2.5}>
                          2.5
                        </MenuItem>
                        <MenuItem key="distance-3" value={3}>
                          3
                        </MenuItem>
                        <MenuItem key="distance-5" value={5}>
                          5
                        </MenuItem>
                        <MenuItem key="distance-7" value={7}>
                          7
                        </MenuItem>
                        <MenuItem key="distance-10" value={10}>
                          10
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <TextField
                        value={`${
                          realeflowCompFilters?.squareFeet?.min || 0
                        }-${
                          realeflowCompFilters?.squareFeet?.max || ''
                        }`}
                        label={'Square Feet'}
                        onClick={toggleRealeflowCompFilters('sqft')}
                      />
                    </FormControl>
                    <Menu
                      anchorEl={realeflowCompMenus['sqft']}
                      keepMounted
                      open={Boolean(realeflowCompMenus['sqft'])}
                      onClose={toggleRealeflowCompFilters('sqft')}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      slotProps={{ list: { sx: { p: 0 } } }}
                    >
                      <Box sx={{ p: '0.5rem' }}>
                        <Grid
                          container
                          direction={'row'}
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'squareFeet.min'}
                              value={
                                realeflowCompFilters?.squareFeet?.min
                              }
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'squareFeet.min',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Square Feet Min'}
                            />
                          </Grid>
                          <Grid size={1}>
                            <Typography>-</Typography>
                          </Grid>
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'squareFeet.max'}
                              value={
                                realeflowCompFilters?.squareFeet?.max
                              }
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'squareFeet.max',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Square Feet Max'}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Menu>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <TextField
                        value={`${
                          realeflowCompFilters?.yearBuilt?.min || 0
                        }-${
                          realeflowCompFilters?.yearBuilt?.max || ''
                        }`}
                        label={'Year Built'}
                        onClick={toggleRealeflowCompFilters(
                          'yearBuilt',
                        )}
                      />
                    </FormControl>
                    <Menu
                      anchorEl={realeflowCompMenus['yearBuilt']}
                      keepMounted
                      open={Boolean(realeflowCompMenus['yearBuilt'])}
                      onClose={toggleRealeflowCompFilters(
                        'yearBuilt',
                      )}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      slotProps={{ list: { sx: { p: 0 } } }}
                    >
                      <Box sx={{ p: '0.5rem' }}>
                        <Grid
                          container
                          direction={'row'}
                          wrap="nowrap"
                          sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'yearBuilt.min'}
                              value={
                                realeflowCompFilters?.yearBuilt?.min
                              }
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'yearBuilt.min',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Year Built Min'}
                            />
                          </Grid>
                          <Grid size={1}>
                            <Typography>-</Typography>
                          </Grid>
                          <Grid size={5}>
                            <NumericFormat
                              customInput={TextField}
                              fullWidth={true}
                              //isNumericString={true}
                              decimalScale={0}
                              name={'yearBuilt.max'}
                              value={
                                realeflowCompFilters?.yearBuilt?.max
                              }
                              allowNegative={false}
                              onValueChange={(values) => {
                                const { value } = values
                                const event = {
                                  target: {
                                    name: 'yearBuilt.max',
                                    value: value,
                                    type: 'number',
                                  },
                                  preventDefault: () => {
                                    return null
                                  },
                                }
                                onChangeRealeflowFilter(event)
                              }}
                              type={'text'}
                              onFocus={(event) => {
                                event.target.select()
                              }}
                              variant="outlined"
                              //margin='dense'
                              label={'Year Built Max'}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Menu>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <InputLabel id="demo-simple-select-label">
                        Sold Date
                      </InputLabel>
                      <Select
                        label="Sold Date"
                        value={realeflowCompFilters.lastSoldDays}
                        onChange={onChangeRealeflowFilter}
                        name="lastSoldDays"
                        sx={{ marginBottom: 2 }}
                      >
                        <MenuItem
                          key="lastSoldDays-null"
                          value={null}
                        >
                          All time
                        </MenuItem>
                        <MenuItem key="lastSoldDays-30" value={30}>
                          1 Month
                        </MenuItem>
                        <MenuItem key="lastSoldDays-60" value={60}>
                          2 Months
                        </MenuItem>
                        <MenuItem key="lastSoldDays-90" value={90}>
                          3 Months
                        </MenuItem>
                        <MenuItem key="lastSoldDays-180" value={180}>
                          6 Months
                        </MenuItem>
                        <MenuItem key="lastSoldDays-365" value={365}>
                          1 Year
                        </MenuItem>
                        <MenuItem key="lastSoldDays-730" value={730}>
                          2 Year
                        </MenuItem>
                        <MenuItem
                          key="lastSoldDays-1095"
                          value={1095}
                        >
                          3 Year
                        </MenuItem>
                        <MenuItem
                          key="lastSoldDays-1825"
                          value={1825}
                        >
                          5 Year
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      <InputLabel id="demo-simple-select-label">
                        Property Type
                      </InputLabel>
                      <Select
                        label="Property Type"
                        value={realeflowCompFilters.propertyType}
                        onChange={onChangeRealeflowFilter}
                        name="propertyType"
                        sx={{ marginBottom: 2 }}
                      >
                        <MenuItem
                          key="SINGLE_FAMILY_RESIDENTIAL"
                          value={'SINGLE_FAMILY_RESIDENTIAL'}
                        >
                          Single
                        </MenuItem>
                        <MenuItem
                          key="CONDOMINIUM"
                          value={'CONDOMINIUM'}
                        >
                          Condo
                        </MenuItem>
                        <MenuItem key="TOWNHOME" value={'TOWNHOME'}>
                          Townhome
                        </MenuItem>
                        <MenuItem
                          key="MULTIFAMILY"
                          value={'MULTIFAMILY'}
                        >
                          Multi
                        </MenuItem>
                        <MenuItem key="APARTMENT" value={'APARTMENT'}>
                          Apartment
                        </MenuItem>
                        <MenuItem key="OTHER" value={'OTHER'}>
                          Other
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <FormControl
                      variant="outlined"
                      margin="dense" sx={strategyMinSelectSx}>
                      {/* <InputLabel id="demo-simple-select-label">
                        Status
                      </InputLabel> */}
                      <Autocomplete
                        multiple
                        //id="fixed-tags-demo"
                        options={realeflowStatusValues}
                        getOptionLabel={(option) => {
                          return option?.label
                        }}
                        disableCloseOnSelect
                        value={realeflowCompFilters.status}
                        onChange={(event, value) =>
                          onChangeRealeflowFilter({
                            target: {
                              value,
                              name: 'status',
                              type: 'text',
                            },
                          })
                        }
                        renderOption={(
                          props,
                          option,
                          { selected },
                        ) => (
                          <li {...props}>
                            <Checkbox
                              icon={
                                <CheckBoxOutlineBlank fontSize="small" />
                              }
                              checkedIcon={
                                <CheckBox
                                  fontSize="small" sx={{ color: '#2296F3' }}/>
                              }
                              checked={selected} sx={{ marginRight: '8px' }}/>
                            {option?.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Status"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  {/* Add more filter buttons here */}
                  <Typography sx={strategyFlexGrowSx} />
                  <Grid>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={triggerRealeflowSearchReset}
                    >
                      Reset
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={
                        isEmpty(realeflowIncludedIds) &&
                        isEmpty(realeflowExcludedIds)
                          ? triggerRealeflowSearch
                          : () => setOpenSearchWarning(true)
                      }
                    >
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {/* Map Section */}
              <Grid size={5}>
                <Map
                  properties={[property]}
                  comps={map(
                    stableSort(
                      filter(
                        results?.data?.getRealeflowCompData,
                        (data) => {
                          const { property } = data
                          return !includes(
                            realeflowExcludedIds,
                            property?._id,
                          )
                        },
                      ),
                      getSorting(
                        realeflowOrder?.order,
                        realeflowOrder?.orderBy,
                      ),
                    ),
                    (data) => data.property,
                  )}
                  streetView={false}
                  shared={props.shared || props.public}
                  path={realeflowPath}
                  setPath={setRealeflowPath}
                  noInfoWindow
                  compWindow
                  customIcon={'/images/deal-sauce-map-icon.png'}
                  height="1000px"
                />
              </Grid>

              {/* Property List Section */}
              <Grid size={7} sx={strategyOverflowScrollSx}>
                <Table sx={[{ whiteSpace: 'nowrap', mb: 0 }, {
                  width: "100%",
                  marginBottom: "1rem",
                  fontSize: "1rem",
                  "& th, & td": { padding: "0.75rem", borderTop: "1px solid #e4e5f0", verticalAlign: "middle" },
                  "& thead th": {
                    textTransform: "uppercase",
                    background: "#f4f5fd",
                    fontSize: "0.875rem",
                    verticalAlign: "middle",
                    borderBottom: "2px solid #e4e5f0",
                  },
                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87)" },
                }]}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <IconButton
                          onClick={() => toggleIncludeAllComp()}
                        >
                          <FontAwesomeIcon
                            icon={['far', 'thumbs-up']}
                            sx={{
                              color:
                                filter(
                                  results?.data?.getRealeflowCompData,
                                  (data) => {
                                    const { property } = data
                                    return !includes(
                                      realeflowExcludedIds,
                                      property?._id,
                                    )
                                  },
                                )?.length <=
                                realeflowIncludedIds?.length
                                  ? 'blue'
                                  : undefined,
                            }}
                          />
                        </IconButton>
                        #
                      </TableCell>
                      <TableCell
                        key={'Address'}
                        //style={{ whiteSpace: 'nowrap' }}
                        sortDirection={
                          realeflowOrder?.orderBy ===
                          'property.address_number'
                            ? realeflowOrder?.order
                            : false
                        } sx={{ whiteSpace: 'nowrap' }}>
                        {'property.address_number' ? (
                          <TableSortLabel
                            active={
                              realeflowOrder?.orderBy ===
                              'property.address_number'
                            }
                            direction={realeflowOrder?.order}
                            onClick={(event) =>
                              handleRequestSort(
                                event,
                                'property.address_number',
                              )
                            }
                          >
                            {'Address'}
                            {realeflowOrder?.orderBy ===
                            'property.address_number' ? (
                              <span style={visuallyHidden}>
                                {realeflowOrder?.order === 'desc'
                                  ? 'sorted descending'
                                  : 'sorted ascending'}
                              </span>
                            ) : null}
                          </TableSortLabel>
                        ) : (
                          'Address'
                        )}
                      </TableCell>
                      <TableCell>Google Search</TableCell>
                      {map(
                        slice(realeflowTableHeaders, 1),
                        (column) => (
                          <TableCell
                            key={column.title}
                            //style={{ whiteSpace: 'nowrap' }}
                            align={column.align}
                            sortDirection={
                              realeflowOrder?.orderBy === column.name
                                ? realeflowOrder?.order
                                : false
                            } sx={{ whiteSpace: 'nowrap' }}>
                            {column.name ? (
                              <TableSortLabel
                                active={
                                  realeflowOrder?.orderBy ===
                                  column.name
                                }
                                direction={realeflowOrder?.order}
                                onClick={(event) =>
                                  handleRequestSort(
                                    event,
                                    column.name,
                                  )
                                }
                              >
                                {column.title}
                                {realeflowOrder?.orderBy ===
                                column.name ? (
                                  <span style={visuallyHidden}>
                                    {realeflowOrder?.order === 'desc'
                                      ? 'sorted descending'
                                      : 'sorted ascending'}
                                  </span>
                                ) : null}
                              </TableSortLabel>
                            ) : (
                              column.title
                            )}
                          </TableCell>
                        ),
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow key={'Subject'}>
                      <TableCell>Subject Property</TableCell>
                      <TableCell>
                        <Typography>{property?.address}</Typography>
                        <Typography>
                          {property?.city}, {property.state}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => {
                            window.open(
                              `https://www.google.com/search?q=${property?.address} ${property?.city}, ${property.state}`,
                              '_blank',
                              // 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400',
                            )
                          }}
                        >
                          <FontAwesomeIcon
                            icon={['fab', 'google']}
                          />
                        </IconButton>
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>{sum(property.beds)}</TableCell>
                      <TableCell>{sum(property.baths)}</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>
                        {property.afterRepairValue}
                      </TableCell>
                      <TableCell>{property?.sqft}</TableCell>
                      <TableCell>{property?.year}</TableCell>
                    </TableRow>
                    {map(
                      stableSort(
                        filter(
                          results?.data?.getRealeflowCompData,
                          (data) => {
                            const { property } = data
                            return !includes(
                              realeflowExcludedIds,
                              property?._id,
                            )
                          },
                        ),
                        getSorting(
                          realeflowOrder?.order,
                          realeflowOrder?.orderBy,
                        ),
                      ),
                      (data, index) => {
                        const { property } = data
                        const address =
                          property?.mailing_std_full_street_address ||
                          property?.address_number +
                            ' ' +
                            property?.address_direction_pre +
                            ' ' +
                            property?.address_street +
                            ' ' +
                            property?.address_direction_post +
                            ' ' +
                            (property?.address_suffix || '')
                        return (
                          <TableRow sx={strategyRelPosSx}>
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  toggleIncludeComp(property._id)
                                }
                              >
                                <FontAwesomeIcon
                                  icon={['far', 'thumbs-up']}
                                  sx={{
                                    color: includes(
                                      realeflowIncludedIds,
                                      property._id,
                                    )
                                      ? 'blue'
                                      : undefined,
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  toggleExcludeComp(property._id)
                                }
                                disabled={includes(
                                  realeflowIncludedIds,
                                  property._id,
                                )}
                              >
                                <FontAwesomeIcon
                                  icon={['far', 'thumbs-down']}
                                />
                              </IconButton>
                              {index + 1}
                            </TableCell>
                            <TableCell>
                              <Typography>{address}</Typography>
                              <Typography>
                                {property?.address_city},{' '}
                                {property?.address_state}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() => {
                                  window.open(
                                    `https://www.google.com/search?q=${address} ${property?.address_city}, ${property?.address_state}`,
                                    '_blank',
                                    // 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400',
                                  )
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={['fab', 'google']}
                                />
                              </IconButton>
                            </TableCell>
                            {map(
                              slice(realeflowTableHeaders, 1),
                              (column) => (
                                <TableCell>
                                  <div>
                                    {column.formatter
                                      ? column.formatter(
                                          get(data, column.name),
                                        )
                                      : get(data, column.name)}
                                  </div>
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        )
                      },
                    )}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'flex-end' }}>
            <Button variant="outlined" onClick={handleFindMenuClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={checkForRealeflowDups}
            >
              Import
            </Button>
          </DialogActions>
        </BlockUi>
      </Dialog>

      <Dialog
        open={openSearchWarning}
        onClose={() => setOpenSearchWarning(false)}
      >
        <DialogContent>
          <DialogContentText>
            Warning! Searching again will reset your list of approved
            and rejected comps. Do you wish to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpenSearchWarning(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              triggerRealeflowSearch()
              setOpenSearchWarning(false)
            }}
          >
            Search
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openNoCompWarning}
        onClose={() => setOpenNoCompWarning(false)}
      >
        <DialogContent>
          <DialogContentText>
            Warning! You have not selected any comps to import. Please
            press the thumb up in order to select a comp
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpenNoCompWarning(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDuplicateWarning}
        onClose={() => setOpenDuplicateWarning(false)}
      >
        <DialogContent>
          <DialogContentText>
            Warning! You already have {duplicateComps?.length} comps
            that are duplicates of those you selected. Do you want to
            add them as duplicates or overwrite the existing comps?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpenDuplicateWarning(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              deleteDuplicates()
              importRealeflowComps()
              setOpenDuplicateWarning(false)
            }}
          >
            Overwrite
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              importRealeflowComps()
              setDuplicateComps([])
              setOpenDuplicateWarning(false)
            }}
          >
            Duplicate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withSession(CenterPageComps)
